import { memo, useState, useEffect, useCallback, useMemo, forwardRef, createRef, useImperativeHandle, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import { BzChip, BzInputText, BzButton, BzToolTip, BzTabs, BzTab, BzDotsLoader, BzDatePicker, BzModal, BzModalHeader, BzModalBody, BzModalTitle, BzDropdown } from '../../components';
import { WATCHLIST_GRID_INDEX, SUPPORT_RESISTANCE_VIEW, ORDER_PRODUCT_TYPES, ORDER_ENTRY_BUTTON_TOGGLE, MARKET_SEGMENT_ID, ORDER_VALIDITY, MSG_MASTER, ORDER_TYPES, SCRIP_INSTRUMENTS, ORDER_ENTRY_TYPES, APP_INFO_PARAMS, ORDER_ENTRY_QTY_DEFAULT_VALUES, ORDER_ENTRY_IS_BANNED_SCRIP_STATUS, OPTION_CHAIN, EXCHANGE_NAME_NOTIFICATION, ORDER_ENTRY_CONSTANTS, MAPPED_MARKET_SEGMENT_ID, SEGMENT_CASH, DEPOSITORY_CDSL, DEPOSITORY_NSDL, EXCHANGE_NAME_API, FACILITY_NUM, LOCATIONS, LAYOUT_TYPE, GTD_DAYS_FOR_NCDEX, SIDE_TRAY_EXPAND_PERCENTAGE, SURV_MEASURE_POPUP_ACTION, VALIDITY_TYPES, DISPLAY_EXCHANGE_NAME, ARR_ORDER_TYPES, OPTION_TYPES } from "../../utils/global_variables";
import { CalculateDays, convertNumberWithCommasForCurrency, convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId, getAppInfoData, getDecryptLocalStorage, getGSMGradeDescriptionFromScrip, getGroupedSegement, getMappedMktSegIdFromApiExchangeName, getMktSegIdFromApiExchangeName, getProductTypeValue, handleKeyDownOnDiv, isValidDecimalDigits, roundToNearest, setEncryptLocalStorage, validateLTPPriceBand, handleMTFPledgeRequest, calculateSupportRestistanceValues, hasUserGrantedPOA } from "../../utils/global_functions";
import { useWFHMessages } from '../../hooks';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { toastConfig } from "../../redux/actions/toast";
import SupportResistance from '../Analysis/SupportResistance';
import AllExchangesMarketDepth from '../AllExchangesMarketDepth';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import { getBannedScripStatus, getMarginPlusParams, getMarketStatus, getScripOrderInfo, getSpreadOrder, setCautionaryMessageFromPopup, updateResetScrip, updateSingleScripOrderConfirmed } from '../../redux/actions/orders';
import uniqBy from 'lodash/uniqBy';
import { sendTouchlineRequest } from '../../apis/web_socket';
import MarketDepthGrid from '../MarketOverview/MarketDepthGrid';
import { _validateRange, _getIsUserAllowedBracketCover, _getOrderEntryAllExchangeWiseProductTypes, _getScripDPRRange, _handleOrderEntryLiveData, _orderEntryComputeBuySideMPPriceRange, _orderEntryComputeMPRange, _orderEntryComputeSellSideMPPriceRange } from '../../controllers/orders';
import { InlineScripSeach } from '../Search';
import moment from 'moment';
import { setScripOverviewData } from '../../redux/actions/marketOverview';
import { updateScripAndOptionData } from '../../redux/actions/optionChain';
import { updateUserPreference } from '../../redux/actions/header';
import dayjs from 'dayjs';
import Edis from '../../screens/Edis';
import { getEDISSummaryDetails } from '../../redux/actions/edis';
import { useLocation } from 'react-router';
import { getScripInfo } from '../../redux/actions/scripInfo';
import useAnalyticsEventTracker from '../../hooks/useAnalyticsEventTracker';
import { getInteropConfigurationDetails } from '../../redux/actions/auth';


const alertTimeout = 5000;

const CustomDropdownToggle = forwardRef(({ children, onClick, className }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        className={className}
    >
        {children}
    </div>
));

//Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
const OrderByDropdown = memo(({ handleOnSelectOrderOptionChange, orderQuantityCaption, handleOrderInputs, scripOrderInfo }) => {
    const handleSetDefaultOnClick = (e, objSelectedOrderBy) => {
        if (scripOrderInfo?.length > 0 && !objSelectedOrderBy.isDefault) {
            objSelectedOrderBy.isDefault = true;
            const strScripSegment = getGroupedSegement(scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE], scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT]);
            let objUserOrderPreference = getDecryptLocalStorage('PREFERRED_ORDER_SELECTION');
            if (objUserOrderPreference && objUserOrderPreference?.length > 0) {
                objUserOrderPreference = JSON.parse(objUserOrderPreference);
                objUserOrderPreference[strScripSegment] = objSelectedOrderBy;
            } else {
                objUserOrderPreference = { [strScripSegment]: objSelectedOrderBy };
            }
            setEncryptLocalStorage('PREFERRED_ORDER_SELECTION', JSON.stringify(objUserOrderPreference));
        }
    };

    return (
        <Dropdown className='d-flex align-items-center'>
            <Dropdown.Toggle as={CustomDropdownToggle} className='icon-12 icon-arrowdown icon-dark ms-2'></Dropdown.Toggle>
            <Dropdown.Menu>
                {orderQuantityCaption.map((eachOption, i) => (
                    <Dropdown.Item onClick={(e) => {
                        handleOnSelectOrderOptionChange({ target: { name: 'orderBy', value: eachOption?.type } });
                        if (eachOption?.type == 'Amount') {
                            //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - Start
                            handleOrderInputs({ target: { name: 'scripAmount', value: '0' } });
                            handleOrderInputs({ target: { name: 'scripLot', value: '0' } });
                            handleOrderInputs({ target: { name: 'scripQuantity', value: '' } });
                            // handleOrderInputs(curr => ({ ...curr, quantity: 0, scripQuantity: 0, scripLot: 0, scripAmount: 1 }));
                        } else if (eachOption?.type == 'Lot') {
                            handleOrderInputs({ target: { name: 'scripAmount', value: '' } });
                            handleOrderInputs({ target: { name: 'scripLot', value: '0' } });
                            // handleOrderInputs(curr => ({ ...curr, quantity: 0, scripQuantity: 0, scripLot: 1, scripAmount: 0 }));
                        } else if (eachOption?.type == 'Quantity') {
                            handleOrderInputs({ target: { name: 'scripAmount', value: '' } });
                            handleOrderInputs({ target: { name: 'scripLot', value: '' } });
                            handleOrderInputs({ target: { name: 'scripQuantity', value: '0' } });
                            // handleOrderInputs(curr => ({ ...curr, quantity: 0, scripQuantity: 0, scripLot: 1, scripAmount: 0 }));
                            //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - End
                        }
                    }} key={i} value={eachOption?.type}>
                        <Row className='g-0'>
                            <Col md={7} className='d-flex justify-content-start align-items-center text-wrap'>
                                <div className='text-wrap'>{eachOption?.type}</div>
                            </Col>
                            <Col md={5} className='d-flex justify-content-end align-items-center'>
                                <div onClick={(e) => handleSetDefaultOnClick(e, eachOption)} className='font-medium font-size2 color-primary mx-2 p-t-3'>{eachOption?.isDefault ? 'Default' : 'Set Default'}</div>
                                {
                                    eachOption?.isDefault &&
                                    <div className='icon-16 icon-checktick icon-primary'></div>
                                }
                            </Col>
                        </Row>
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
});
//Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - End

//Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
// SumitG and Azim Khan - 05-12-23 
export const ProductTypeDropdown = memo(({ selectOrderOption, arrAllExchangeWiseProductTypes, handleOnSelectOrderOptionChange, objActiveExchangeUserPreference, userPreference, scripOrderInfo, isModifyOrder, bIsHoldingsSell }) => {
    const [show, setShow] = useState(false);
    const userId = useSelector(state => state.auth.userId);
    const dispatch = useDispatch();
    // Vaibhav Singh: NSE EQ Order Entry: Issue with showing delivery in holdin solved : Start
    const location = useLocation();
    useEffect(() => {
        if (location?.pathname === LOCATIONS.PORTFOLIO) {
            // selectOrderOption["productTypeDesc"] = "DELIVERY02";
        }
    }, [selectOrderOption]);
    // Vaibhav Singh: NSE EQ Order Entry: Issue with showing delivery in holdin solved : End
    const handleSetDefaultOnClick = (e, objSelectedProductType) => {
        setShow(false);
        if (userPreference?.length > 0 && scripOrderInfo?.length > 0) {
            const objActiveUserPreference = userPreference[userPreference?.length - 1];
            const userPreferenceExchanges = objActiveUserPreference?.sExchange?.length > 0 ? JSON.parse(objActiveUserPreference?.sExchange) : [];
            const nIndex = userPreferenceExchanges?.findIndex(exchangType => exchangType?.marketSegmentId === scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
            if (nIndex >= 0) {
                userPreferenceExchanges[nIndex].productType = objSelectedProductType?.sDefaultProductType;
                const marketSegmentId = getMktSegIdFromApiExchangeName(scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]);
                setEncryptLocalStorage(`PRODUCT_TYPE_${userId}_${marketSegmentId}`, objSelectedProductType?.sDefaultProductType?.toUpperCase());
            } else {
                const objExchangeTab = {
                    "exchange": EXCHANGE_NAME_NOTIFICATION?.[scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]],
                    "productType": objSelectedProductType?.sDefaultProductType,
                    "marketSegmentId": getMktSegIdFromApiExchangeName(scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]),
                    "selected": false,
                    "protection": 0
                };
                userPreferenceExchanges?.push(objExchangeTab);
                /* Deepti B. Persisting default checked product type in local storage */
                setEncryptLocalStorage(`PRODUCT_TYPE_${userId}_${objExchangeTab.marketSegmentId}`, objExchangeTab?.sDefaultProductType?.toUpperCase());
            }
            const payload = {
                sExchange: JSON.stringify(userPreferenceExchanges)
            };
            dispatch(updateUserPreference(objActiveUserPreference, payload));
        }
    };


    return (
        <div className='d-flex align-items-center' show={show} onToggle={nextStatus => isModifyOrder || bIsHoldingsSell || !arrAllExchangeWiseProductTypes ? setShow(false) : setShow(nextStatus)}>
            <div className={`Bzmodalselect-dropdown w-100 ${isModifyOrder ? 'disabled' : ''}`}>
                <BzDropdown >
                    <Dropdown.Toggle
                        tabIndex={isModifyOrder || bIsHoldingsSell ? -1 : 0}
                        className={`btn-default ${isModifyOrder || bIsHoldingsSell ? 'disabled' : ''}`}
                        data-testid="toggleProductTypeDropdown"
                    >
                        {selectOrderOption?.productTypeDesc?.length > 10 ? selectOrderOption?.productTypeDesc?.slice(0, 10) + '...' : selectOrderOption?.productTypeDesc}
                    </Dropdown.Toggle>
                    <Dropdown.Menu defaultValue={selectOrderOption?.productTypeDesc}>
                        {
                            arrAllExchangeWiseProductTypes?.length > 0 && arrAllExchangeWiseProductTypes?.map((objEachOption, i) => (
                                <Dropdown.Item
                                    onClick={() => {
                                        handleOnSelectOrderOptionChange({ target: { name: 'productType', value: objEachOption?.sDefaultProductType } });
                                    }}
                                    key={i}
                                    value={objEachOption?.sDefaultProductType}
                                >
                                    <Row className='g-0'>
                                        <Col md={7} className='d-flex justify-content-start align-items-center text-wrap'>
                                            <div className='text-wrap' data-testid={objEachOption?.sDescription}>{objEachOption?.sDescription}</div>
                                        </Col>
                                        <Col md={5} className='d-flex justify-content-end align-items-center'>
                                            <div className='font-medium font-size2 color-primary mx-2 p-t-3' onClick={(e) => handleSetDefaultOnClick(e, objEachOption)}>{objActiveExchangeUserPreference?.productType === objEachOption?.sDefaultProductType ? 'Default' : 'Set Default'}</div>
                                            {
                                                objActiveExchangeUserPreference?.productType === objEachOption?.sDefaultProductType &&
                                                <div className='icon-16 icon-checktick icon-primary'></div>
                                            }
                                        </Col>
                                    </Row>
                                </Dropdown.Item>
                            ))
                        }
                    </Dropdown.Menu>
                </BzDropdown>
            </div>
        </div>
    );
});
//Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - End

//Maaz A : 09-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - LiveFeed Issue Fix - Start
const OrderSingleScrip = forwardRef(({ layoutType = LAYOUT_TYPE.HORIZONTAL, isHeader, arrAllExchangeWiseProductTypes, setArrAllExchangeWiseProductTypes, bIsPlaceOrderBtnDisabled, handleOrderStepsOnChange, orderInputs, toggleBracketOrder, setToggleBracketOrder, selectOrderOption, handleOnSelectOrderOptionChange, handleOrderInputs, marginInfoHandler, isScripPrice, setIsScripPrice, arrMarginInfo, scripOrderInfo, market, activeButtonToggleIndex = ORDER_ENTRY_BUTTON_TOGGLE.BUY, isBrokerageDisabled, activeMktSegId, isModifyOrder = false, bIsHoldingsSell = false, objSelectOrderOptionInit, isReOrder = false, validityTypes, setSelectOrderOption, nOriginalQty, setOrderInputs, setIsExpanded, ...props }, ref) => {
    //Maaz A : 09-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - LiveFeed Issue Fix - End
    const dispatch = useDispatch();
    const [supportResistance, setSupportResistance] = useState({});
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    const inlineSearchRef = useRef();
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Endf
    const [marketDepthActiveTab, setMarketDepthActiveTab] = useState('market_depth');
    const [marketDepthTab, setMarketDepthTab] = useState('nse');
    const [isShowMarketDepth, setIsShowMarketDepth] = useState(false);
    const marketDepthRef = useRef(null);
    const userId = useSelector(state => state.auth.userId);
    const handleMarketDepthClick = () => {
        setIsShowMarketDepth(curr => {
            if (!curr) {
                setTimeout(() => {
                    marketDepthRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 100);
            }
            return !curr;
        });

    };

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    const [arrScripInformation, setArrScripInformation] = useState([]);
    const [arrActiveScripInformation, setArrActiveScripInformation] = useState([]);
    const [bIsScripPriceDisabled, setBIsScripPriceDisabled] = useState(false);

    const [inputSearch, setInputSearch] = useState(false);
    const [profDesc, setProfDesc] = useState(false);
    const [bracketCoverOrderPriceRange, setBracketCoverOrderPriceRange] = useState({});
    // Ajitesh : 07/12/2023: BT-109135: Breeze eDIS implementation - Start
    const [singleScripDataForEdis, setSingleScripDataForEdis] = useState(null);
    const [scripSummary, setScripSummary] = useState([]);
    const [amoScripDetailsForValidation, setAmoScripDetailsForValidation] = useState([]); // Ajitesh 19/03/2024 - State to save AMO response from eDIS flow
    const [exchgAndMktSegData, setExchgAndMktSegData] = useState({});
    // Ajitesh : 07/12/2023: BT-109135: Breeze eDIS implementation - End
    useEffect(() => {
        const qtyInput = document.getElementById('qtyInput');
        if (qtyInput) {
            qtyInput?.focus();
            qtyInput?.select();
        }
    }, []);

    const userPreference = useSelector(state => state.notification.userPreference);
    const arrScripExchanges = useSelector(state => state.orders.arrScripExchanges);
    const ltpPriceBandMaster = useSelector(state => state.orders.ltpPriceBandMaster);
    const isLoadingMarginInfo = useSelector(state => state.orders.isLoadingMarginInfo);
    const bannedScripStatus = useSelector(state => state.orders.bannedScripStatus);
    const productTypes = useSelector(state => state.orders.productTypes);
    const marketStatus = useSelector(state => state.orders.marketStatus);
    const isOrderConfirmed = useSelector(state => state.orders.isSingleScripOrderConfirmed);
    const holdingsScrips = useSelector(state => state.holdings.holdingsScrips);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const appInfo = useSelector(state => state.appInfo.appInfo);
    // Ajitesh : 07/12/2023: BT-109135: Breeze eDIS implementation - Start
    const modals = useSelector(state => state.modals.modals);
    const interopConfigDetails = useSelector(state => state.auth.interopConfig); // interop data to make edis scrips summary api call
    const userDpDetails = useSelector(state => state.auth.dpDetails);
    const edisSummaryDetails = useSelector(state => state.edis.edisSummaryDetails);

    const orderData = useSelector(state => state.modals?.modalData?.orderData);
    const modelData = useSelector(state => state.modals?.modalData);
    // Ajietsh 18-06-2024 Get multileg data from state to be used to show scrip information when user switch from multi scrip to single scrip
    const multiLegData = useSelector(state => state.orders.multiLegData);
    //BT-138033 : Order Slicing: ManasaB : 26-06-2024 - Start
    const [arrOrderSlicingInfo, setArrOrderSlicingInfo] = useState([]);
    const objCFT = useSelector(state => state?.auth?.objCFT);
    //BT-138033 : Order Slicing: ManasaB : 26-06-2024 - End
    // API call to get edis scrip data to compare qty and decide if flow required
    const getScripDataForEdis = () => {
        let mktSegmentId = MAPPED_MARKET_SEGMENT_ID.MAPPED_COMBINED_CASH;
        let token = -1;
        let productTypeForApi = "";
        if (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.MTF) {
            productTypeForApi = ORDER_PRODUCT_TYPES.MTF;
        }
        const payload = {
            "mktSegmentId": mktSegmentId,
            "token": token,
            "productTypeForApi": productTypeForApi
        };
        dispatch(getEDISSummaryDetails(payload));
    };


    useEffect(() => {
        if (!interopConfigDetails.length) {
            dispatch(getInteropConfigurationDetails());
        }
    }, [interopConfigDetails]);



    const arrOrderTypeOptions = useMemo(() => {
        if (scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES && (scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT]?.includes(SCRIP_INSTRUMENTS.OPT) || scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE] === OPTION_TYPES.PE || scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE] === OPTION_TYPES.CE)) {

            return ARR_ORDER_TYPES?.filter((item) => item !== ORDER_ENTRY_TYPES.SL_MKT);
        } else {
            return ARR_ORDER_TYPES;
        }
    }, [scripOrderInfo]);

    useEffect(() => {
        // Ajitesh - No longer need data refresh, call eDIS API on component load
        if (interopConfigDetails.length > 0) {
            interopConfigDetails.forEach((elem) => {
                if (elem.nInteropPreferredCCL !== -1 &&
                    elem.nCombinedSegmentId === MAPPED_MARKET_SEGMENT_ID.MAPPED_COMBINED_CASH &&
                    elem.sSegment === SEGMENT_CASH
                ) {
                    if (userDpDetails.data) {
                        // TODO: Check how we can determine if user has multiIsInEnabled with Rajendra
                        let isMultiIsinEnabled = getAppInfoData(APP_INFO_PARAMS.APP_MULTI_ISIN_NSDL, appInfo);
                        if ((userDpDetails.data.sDepository === DEPOSITORY_CDSL ||
                            (userDpDetails.data.sDepository === DEPOSITORY_NSDL && isMultiIsinEnabled)) &&
                            userDpDetails.data.sDPId !== "" &&
                            userDpDetails.data.nBeneficiaryAccountNumber !== ""
                        ) {
                            getScripDataForEdis();
                        }
                    }
                }
            });
        }
    }, [interopConfigDetails, userDpDetails]);

    // This useEffect checks if scrip user is trying to SELL is in holdings and stores it in state variable. This hook is also called once edis is complete and user clicks "PLace order" button and is directed straight to COnfirm dialog as edis for the scrip is already done
    useEffect(() => {
        if (Object.keys(edisSummaryDetails).length) {
            // Changing comparison logic to allow BSE scrips to be sold in NSE and vice versa
            let objScripHolding = holdingsScrips?.find(obj => obj?.ISIN === scripOrderInfo?.[WATCHLIST_GRID_INDEX.ISIN_CODE]);
            let scripOrderData = [];
            if (objScripHolding?.ISIN) {
                // Check if scrip that user is trying to sell exists in edis api and is not in OPEN ORDER state
                scripOrderData = edisSummaryDetails?.edis_summary?.length && edisSummaryDetails?.edis_summary.filter(scrip => scrip.sISINCode === objScripHolding.ISIN && scrip.eDISDPQty > 0);
                if (scripOrderData?.length) {
                    setScripSummary([...scripOrderData]);
                }
                // Prepare single scrip prop for Edis page so we can show scrip that is being sold in "checked" state in grid
                setSingleScripDataForEdis({
                    ...singleScripDataForEdis,
                    sISINCode: objScripHolding.ISIN,
                    scripQuantity: Number(orderInputs.scripQuantity)
                });
            }
        }
    }, [edisSummaryDetails, holdingsScrips, scripOrderInfo, orderInputs, setScripSummary, setSingleScripDataForEdis]);

    // Ajitesh: 30/03/2024 - Function to get exchange and market segment to be sent as payload for AMO edis - Start
    const getExchangeAndMktSegment = () => {
        for (const exchange of objLoginSession?.data?.exchanges) {
            if (exchange === EXCHANGE_NAME_API.NSE_EQ_API) {
                setExchgAndMktSegData({
                    ...exchgAndMktSegData,
                    exchangeName: DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT,
                    marketSegmentId: getMappedMktSegIdFromApiExchangeName(exchange)
                });
                break;
            }
            if (exchange === EXCHANGE_NAME_API.BSE_EQ_API) {
                setExchgAndMktSegData({
                    ...exchgAndMktSegData,
                    exchangeName: DISPLAY_EXCHANGE_NAME.BSE_EXCHANGE_TEXT,
                    marketSegmentId: getMappedMktSegIdFromApiExchangeName(exchange)
                });
                break;
            }
            if (exchange === EXCHANGE_NAME_API.MCXSX_EQ_API) {
                setExchgAndMktSegData({
                    ...exchgAndMktSegData,
                    exchangeName: DISPLAY_EXCHANGE_NAME.MSX_EXCHANGE_TEXT,
                    marketSegmentId: getMappedMktSegIdFromApiExchangeName(exchange)
                });
                break;
            }
        }
    };
    useEffect(() => {
        if (objLoginSession?.data && objLoginSession?.data?.exchanges.length > 0) {
            getExchangeAndMktSegment();
        }
    }, [objLoginSession]);
    // Ajitesh: 30/03/2024 - Function to get exchange and market segment to be sent as payload for AMO edis - End


    // Ajitesh : 07/12/2023: BT-109135: Breeze eDIS implementation - End
    // Vaibhav Singh: NSE EQ Order Entry: Issue with Search margin solved: Start
    useEffect(() => {
        if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] === "" && scripOrderInfo?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN] === arrActiveScripInformation[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
            dispatch(getScripOrderInfo({ isBuySell: activeButtonToggleIndex, activeExchangeId: arrActiveScripInformation[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: arrActiveScripInformation }));
        }
    }, [arrActiveScripInformation, scripOrderInfo]);
    // Vaibhav Singh: NSE EQ Order Entry: Issue with Search margin solved: End
    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
    let objUserOrderPreference = getDecryptLocalStorage('PREFERRED_ORDER_SELECTION');
    if (objUserOrderPreference && objUserOrderPreference?.length > 0) {
        objUserOrderPreference = JSON.parse(objUserOrderPreference);
    } else {
        objUserOrderPreference = {};
    }

    // Ajitesh 18-06-2024 function to get scrip details when user switches from multi scrip to single scrip in reorder mode
    useEffect(() => {
        // scriporderInfo is made blank intentionally from src\containers\PlaceOrderTypes\OrderMultiScrip\index.js
        if (scripOrderInfo?.length === 0 && multiLegData.length > 0) {
            // get scrip information for NSE FNO scrip based on first leg in multileg order
            let abc = dispatch(getScripInfo([{ mkt: getApiExchangeNameFromMktSegId(multiLegData[0]?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]), token: multiLegData[0]?.token }]));
            Promise.resolve(abc).then((resp) => {
                // use the response and populate scripInfo for NSE FNO scrip
                const scripResponse = convertScripResponseWatchlistGrid(resp);
                const scripData = scripResponse[0];
                // set scripInfo with FNO scrip data
                dispatch(getScripOrderInfo({ isBuySell: multiLegData[0].activeButtonToggleIndex, activeExchangeId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData }));
            });
        }
    }, [scripOrderInfo]);

    const orderQuantityCaption = useMemo(() => {
        if (scripOrderInfo?.length > 0) {
            let arrTypeCaption = [];
            const strScripSegment = getGroupedSegement(scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE], scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT]);

            if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
                arrTypeCaption = [{ type: 'Quantity', isDefault: false }, { type: 'Amount', isDefault: false }];
            } else {
                arrTypeCaption = [{ type: 'Lot', isDefault: false }, { type: 'Quantity', isDefault: false }, { type: 'Amount', isDefault: false }];
            }
            if (objUserOrderPreference[strScripSegment]?.type) {
                const nIndex = arrTypeCaption?.findIndex(obj => obj.type === objUserOrderPreference[strScripSegment]?.type);
                if (nIndex >= 0) {
                    arrTypeCaption[nIndex] = objUserOrderPreference[strScripSegment];
                } else { }
            } else { }
            return [...arrTypeCaption];
        } else {
            return [{ type: 'Quantity', isDefault: false }, { type: 'Amount', isDefault: false }];
        }
    }, [scripOrderInfo, objUserOrderPreference]);

    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - End

    //Maaz A : 10-10-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD Order - Start
    const nGTDNoOfDays = useMemo(() => {
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
        if (orderInputs?.gtdDate && orderInputs?.gtdDate?.format) {
            const strGTDSelDate = orderInputs?.gtdDate?.format('DD-MM-YYYY');
            let gtdSelDate = moment(strGTDSelDate, 'DD-MM-YYYY');
            let currDate = moment(moment().format('DD-MM-YYYY'), 'DD-MM-YYYY');
            const nGTDNoOfDays = gtdSelDate.diff(currDate, 'days');
            return nGTDNoOfDays;
        } else {
            return 0;
        }
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
    }, [orderInputs?.gtdDate]);
    //Maaz A : 10-10-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD Order - End

    const arrDistinctScripExchanges = useMemo(() => uniqBy(arrScripExchanges, WATCHLIST_GRID_INDEX.EXCHANGE), [arrScripExchanges]);
    const strSelectedExchName = useMemo(() => getApiExchangeNameFromMktSegId(scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]), [scripOrderInfo]);
    const [MPLowPr, MPHighPr] = useMemo(() => _getScripDPRRange(arrActiveScripInformation).data, [arrActiveScripInformation]);
    const [bIsCoverOrderAllowed, bIsBracketOrderAllowed] = useMemo(() => _getIsUserAllowedBracketCover(objLoginSession).data, [objLoginSession]);
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    useEffect(() => {
        if (arrActiveScripInformation?.length > 0) {
            // Ajitesh 25-06-2024 Adds 4 digits after decimal for support and resistance
            const resitancePivotObj = calculateSupportRestistanceValues(arrActiveScripInformation, 'Classic', '(H+L+C)/3', scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
            setSupportResistance(resitancePivotObj);
        } else { }

    }, [arrActiveScripInformation, scripOrderInfo]);

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

    const derivePriceforMarketOrder = () => {
        let strPrice = 0;
        // if (selectOrderOption?.orderType == ORDER_ENTRY_TYPES.RL_MKT) {

        let dblPrice1 = Math.max(parseFloat(arrActiveScripInformation[WATCHLIST_GRID_INDEX.ASK_PRICE]), parseFloat(arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]));
        let dblPrice2 = Math.max(dblPrice1, parseFloat(arrActiveScripInformation[WATCHLIST_GRID_INDEX.BID_PRICE]));
        strPrice = dblPrice2;

        if (strPrice <= 0)
            strPrice = arrActiveScripInformation[WATCHLIST_GRID_INDEX.CLOSE];
        else { }
        // }
        // else if (selectOrderOption?.orderType == ORDER_ENTRY_TYPES.SL_MKT) {
        //     strPrice = orderInputs?.slTrigger;
        // } else { }

        // if (selectOrderOption?.orderType == ORDER_ENTRY_TYPES.RL_MKT) {
        //(convert from percent to value(100))
        let _dblProtPerc = 0;
        // if (objActiveExchangeUserPreference?.protection)
        //     _dblProtPerc = parseFloat(objActiveExchangeUserPreference?.protection);
        if (orderInputs?.protPercent)
            _dblProtPerc = parseFloat(orderInputs?.protPercent);
        else
            _dblProtPerc = 0;

        let nFinalPrice = 0;
        if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY)
            nFinalPrice = parseFloat(strPrice) * (1 + (parseFloat(_dblProtPerc) / 100));
        else
            nFinalPrice = parseFloat(strPrice) * (1 - (parseFloat(_dblProtPerc) / 100));

        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
        if (!nFinalPrice || isNaN(nFinalPrice)) {
            strPrice = parseFloat(scripOrderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]);
        } else { }
        //roundoff to nearest tick
        nFinalPrice = roundToNearest(nFinalPrice, scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK], 'up');
        let PriceinPaise = parseInt(Math.round(parseFloat((nFinalPrice * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toString())).toString());
        let selPriceTick = scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
        if (PriceinPaise % parseInt(selPriceTick) != 0) {
            //Price correction to nearest value.
            nFinalPrice = (parseFloat(nFinalPrice) - (PriceinPaise % parseInt(selPriceTick)) / parseInt(scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]));
        }
        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
        return strPrice;
    };

    useEffect(() => {
        if (selectOrderOption?.orderType == ORDER_ENTRY_TYPES.RL_MKT || selectOrderOption?.orderType == ORDER_ENTRY_TYPES.SL_MKT) {
            setBIsScripPriceDisabled(true);
        } else {
            setBIsScripPriceDisabled(false);
        }
    }, [selectOrderOption.orderType]);

    useEffect(() => {
        if (selectOrderOption?.orderType == ORDER_ENTRY_TYPES.RL_MKT || selectOrderOption?.orderType == ORDER_ENTRY_TYPES.SL_MKT) {
            let nPriceWithProtPerc = derivePriceforMarketOrder();
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
            nPriceWithProtPerc = parseFloat(nPriceWithProtPerc).toFixed(scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
            handleOrderInputs({ target: { name: 'scripPrice', value: nPriceWithProtPerc } });
        } else { }
    }, [selectOrderOption.orderType, orderInputs?.protPercent]);

    function onInitScripStatus() {

        const strT2TSeriesList = getAppInfoData(APP_INFO_PARAMS.APP_T2T_SERIES_LIST, appInfo);
        const strT2TScripErrorMsg = getAppInfoData(APP_INFO_PARAMS.APP_T2T_SCRIP_ERROR_MESSAGE, appInfo);
        const bIsAmoAllowed = getAppInfoData(APP_INFO_PARAMS.APP_AMO_MODE, appInfo);
        //Maaz A - Checking APP_T2T_SERIES_LIST Scrip and Getting Error Scrip Msg from APP_T2T_SCRIP_ERROR_MESSAGE.
        const { isT2TSeriesScrip, T2TScripErrorMsg } = getT2PDetails(strT2TSeriesList, strT2TScripErrorMsg);
        if (isT2TSeriesScrip) {
            dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: T2TScripErrorMsg }));
        } else { }

        if (bIsAmoAllowed) {
            dispatch(getMarketStatus());
        } else { }

        dispatch(getBannedScripStatus({ mktSegmentId: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], nToken: scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN] }));
    }


    const objActiveExchangeUserPreference = useMemo(() => {
        if (userPreference?.length > 0 && userPreference[userPreference.length - 1]?.sExchange) {
            const arrUserPreferenceProductType = JSON.parse(userPreference[userPreference.length - 1]?.sExchange);
            const objActiveExchangeUserPreference = arrUserPreferenceProductType?.find(obj => obj?.marketSegmentId == scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
            if (objActiveExchangeUserPreference && Object.keys(objActiveExchangeUserPreference).length > 0) {
                return objActiveExchangeUserPreference;
            } else {
                return {};
            }
        } else {
            return {};
        }
    }, [scripOrderInfo, userPreference]);

    // Vinit R : 03-07-2024 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start
    useEffect(() => {
        // Ajitesh: Adds proper condition to add product type so that margin is shown always when API is called
        if (selectOrderOption?.productType) {
            marginInfoHandler(selectOrderOption?.productType);
        }
    }, [activeButtonToggleIndex]);
    // Vinit R : 03-07-2024 : BT-106776 -  Breeze - Display Brokerage and statutory charges - End

    useEffect(() => {
        //Maaz A : Init App Info Handler
        if (scripOrderInfo?.length > 0 && appInfo?.length > 0) {
            const bIsQtyAutoFill = getAppInfoData(APP_INFO_PARAMS.APP_QTY_AUTOFILL, appInfo);
            const nQtyDefaultValue = getAppInfoData(APP_INFO_PARAMS.APP_PRICE_QTY_DEFAULT_VALUE, appInfo);
            const objDefaultProdTypes = getAppInfoData(APP_INFO_PARAMS.APP_DEFAULT_PRODUCT, appInfo);
            //Maaz A - APP_PRICE_QTY_DEFAULT_VALUE auto fill Quantity only if value 1 or 2
            if ((nQtyDefaultValue == ORDER_ENTRY_QTY_DEFAULT_VALUES.SHOW_1 || nQtyDefaultValue == ORDER_ENTRY_QTY_DEFAULT_VALUES.SHOW_2) && selectOrderOption?.isDefaultProductType) {
                //Maaz A - APP_QTY_AUTOFILL auto fill Quantity
                if (bIsQtyAutoFill == true) {
                    if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                        handleOrderInputs({ target: { name: 'scripQuantity', value: scripOrderInfo?.[WATCHLIST_GRID_INDEX.ASK_QTY].toString() } });
                    } else {
                        handleOrderInputs({ target: { name: 'scripQuantity', value: scripOrderInfo?.[WATCHLIST_GRID_INDEX.BID_QUANTITY].toString() } });
                    }
                } else { }
            } else { }

            //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
            if (objActiveExchangeUserPreference?.protection) {
                handleOrderInputs({ target: { name: 'protPercent', value: objActiveExchangeUserPreference?.protection } });
            } else { }
            //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - End
            if (selectOrderOption?.isDefaultProductType) {
                if (arrAllExchangeWiseProductTypes?.length > 0) {
                    const nIndexOfAllowedProduct = arrAllExchangeWiseProductTypes?.findIndex((obj) => obj?.sDefaultProductType === objActiveExchangeUserPreference?.productType);//Azeem K :11-09-2024: to check product is allowed to user
                    // Maaz A : User Preference Product Type Set
                    if (objActiveExchangeUserPreference?.productType && nIndexOfAllowedProduct >= 0) {
                        handleOnSelectOrderOptionChange({ target: { name: 'productType', value: objActiveExchangeUserPreference?.productType } });
                        // Adds condition so that margin info call does not go with empty price which will blank out margin required on UI 
                        if (orderInputs?.scripPrice) {
                            marginInfoHandler(objActiveExchangeUserPreference?.productType);
                        }
                        onInitScripStatus();


                    } else {
                        //Maaz A - Setting Default Prod Types as per APP_DEFAULT_PRODUCT
                        const strDefaultProdType = fetchDefaultProductType(objDefaultProdTypes);
                        if (arrAllExchangeWiseProductTypes.length > 0) {
                            const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType == strDefaultProdType);
                            if (strDefaultProdType && objSelProductType) {
                                if (objSelProductType?.sDescription) {
                                    handleOnSelectOrderOptionChange({ target: { name: 'productType', value: strDefaultProdType } });
                                    handleOnSelectOrderOptionChange({ target: { name: 'productTypeDesc', value: objSelProductType?.sDescription } });
                                    marginInfoHandler(strDefaultProdType);
                                } else { }
                            } else {
                                if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
                                    // For Equities
                                    const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType == ORDER_PRODUCT_TYPES.DELIVERY);
                                    if (objSelProductType?.sDescription) {
                                        handleOnSelectOrderOptionChange({ target: { name: 'productType', value: objSelProductType?.sDefaultProductType } });
                                        handleOnSelectOrderOptionChange({ target: { name: 'productTypeDesc', value: objSelProductType?.sDescription } });
                                        marginInfoHandler(objSelProductType?.sDefaultProductType);
                                    } else if (arrAllExchangeWiseProductTypes?.length > 0) {
                                        handleOnSelectOrderOptionChange({ target: { name: 'productType', value: arrAllExchangeWiseProductTypes[0]?.sDefaultProductType } });
                                        handleOnSelectOrderOptionChange({ target: { name: 'productTypeDesc', value: arrAllExchangeWiseProductTypes[0]?.sDescription } });
                                        marginInfoHandler(arrAllExchangeWiseProductTypes[0]?.sDefaultProductType);
                                    } else { }
                                } else {
                                    // For FNO
                                    const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType == ORDER_PRODUCT_TYPES.CARRYFORWARD);
                                    if (objSelProductType?.sDescription) {
                                        handleOnSelectOrderOptionChange({ target: { name: 'productType', value: objSelProductType?.sDefaultProductType } });
                                        handleOnSelectOrderOptionChange({ target: { name: 'productTypeDesc', value: objSelProductType?.sDescription } });
                                        marginInfoHandler(objSelProductType?.sDefaultProductType);
                                    } else if (arrAllExchangeWiseProductTypes?.length > 0) {
                                        handleOnSelectOrderOptionChange({ target: { name: 'productType', value: arrAllExchangeWiseProductTypes[0]?.sDefaultProductType } });
                                        handleOnSelectOrderOptionChange({ target: { name: 'productTypeDesc', value: arrAllExchangeWiseProductTypes[0]?.sDescription } });
                                        marginInfoHandler(arrAllExchangeWiseProductTypes[0]?.sDefaultProductType);
                                    } else { }
                                }
                            }
                        } else { }
                        onInitScripStatus();
                    }
                } else {
                    //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - Start
                    if (arrAllExchangeWiseProductTypes?.length > 0) {
                        if (selectOrderOption?.productType) {
                            marginInfoHandler(selectOrderOption?.productType, (isReOrder || isModifyOrder) ? orderInputs?.scripQuantity : scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT]);
                        } else { }
                        onInitScripStatus();
                    } else {
                        handleOnSelectOrderOptionChange({ target: { name: 'productType', value: '' } });
                        handleOnSelectOrderOptionChange({ target: { name: 'productTypeDesc', value: '' } });
                    }
                    //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - End
                }
            } else {
                marginInfoHandler(selectOrderOption?.productType);
                // Vaibhav S : 29-02-2024 : BT-102298 Added logic for traded to trade message– End
                onInitScripStatus();
            }
        } else { }
    }, [objActiveExchangeUserPreference?.productType, scripOrderInfo, appInfo, arrAllExchangeWiseProductTypes]);

    useEffect(() => {
        // Maaz A : Market Status API Response Handler
        // Vinit R : BT-102298 12-03-2024 : Single scrip bug fixing  -- Start
        if (marketStatus?.length > 0 && scripOrderInfo?.length > 0 && !isReOrder && !isModifyOrder && !modelData?.data?.isGoback) {
            // Vinit R : BT-102298 12-03-2024 : Single scrip bug fixing  -- End
            for (let i = 0; i < marketStatus.length; i++) {
                if (getApiExchangeNameFromMktSegId(scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]) == marketStatus[i].exchangeSegment) {
                    if (marketStatus[i].marketStatus.toUpperCase() === 'AMO') {
                        handleOnSelectOrderOptionChange({ target: { name: 'isAmo', value: true } });
                    } else {
                        handleOnSelectOrderOptionChange({ target: { name: 'isAmo', value: false } });
                    }
                    break;
                } else { }
            }
        } else { }
    }, [marketStatus]);

    useEffect(() => {
        if (appInfo?.length > 0 && bannedScripStatus?.length > 0) {
            const strMessage = getAppInfoData(APP_INFO_PARAMS.APP_BANNED_SCRIP_MESSAGE, appInfo);

            //Maaz A - Checking Banned Scrip and Getting Banned Scrip Msg from APP_BANNED_SCRIP_MESSAGE.
            if (bannedScripStatus[0][""] == ORDER_ENTRY_IS_BANNED_SCRIP_STATUS.NOT_BANNED)
                var isBannedScrip = false;
            else
                isBannedScrip = true;

            if (isBannedScrip) {
                if (strMessage) {
                    var strBannedScripErrorMsg = strMessage;
                }
                else {
                    strBannedScripErrorMsg = "Security is in banned list, do you want to place order?";
                }
                dispatch(toastConfig({
                    show: true, message: strBannedScripErrorMsg, button: [
                        {
                            btnName: "Yes", className: "btn btn-solid ms-3", onClickHandler: () => {
                                dispatch(toastConfig({ show: false }));
                            }
                        }, {
                            btnName: "No", className: "btn btn-outline-active ms-3", onClickHandler: () => {
                                dispatch(toastConfig({ show: false }));
                                dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': false }]));
                            }
                        }
                    ]
                }));
            } else { }
        } else { }
    }, [appInfo, bannedScripStatus]);

    useEffect(() => {
        if (selectOrderOption?.orderBy === 'Lot') {
            // handleOrderInputs({ target: { name: 'scripLot', value: 1 } });
        } else { }
    }, [selectOrderOption]);

    const fetchDefaultProductType = (objDefaultProdTypes) => {
        let strSelProduct = '';
        if (objDefaultProdTypes) {
            const allowedExchanges = [];
            const _parseDefProdType = objDefaultProdTypes;
            const _defProductKeys = Object.keys(_parseDefProdType);
            _defProductKeys.forEach(element => {
                const filterExch = objLoginSession?.data?.exchanges.filter(exchange => { return exchange == element; });
                if (filterExch?.length > 0) {
                    allowedExchanges.push(filterExch[0]);
                } else { }
            });
            const arrSelectedProductType = objLoginSession?.data?.product_types_exchange[strSelectedExchName];
            if (strSelectedExchName?.includes('EQ')) {
                var nIndex = arrSelectedProductType?.indexOf(ORDER_PRODUCT_TYPES.INTRADAY);
                if (nIndex >= 0) {
                    arrSelectedProductType[nIndex] = ORDER_PRODUCT_TYPES.MARGIN;
                } else { }
            } else {
                // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
                nIndex = arrSelectedProductType?.indexOf(ORDER_PRODUCT_TYPES.DELIVERY);
                // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
                if (nIndex >= 0) {
                    arrSelectedProductType[nIndex] = ORDER_PRODUCT_TYPES.CARRYFORWARD;
                } else { }
            }


            if (allowedExchanges.length > 0) {
                for (let i = 0; i < allowedExchanges.length; i++) {
                    const nMktSegId = getMktSegIdFromApiExchangeName(allowedExchanges[i]);
                    if (nMktSegId == scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]) {
                        strSelProduct = _parseDefProdType[allowedExchanges[i]];
                        //Norwin D 26/05/2022 <Added constant value instead of EQUITIES>
                        if (arrAllExchangeWiseProductTypes?.length > 0 && scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT].toUpperCase() == SCRIP_INSTRUMENTS.EQUITIES && strSelProduct == ORDER_PRODUCT_TYPES.INTRADAY) {
                            strSelProduct = ORDER_PRODUCT_TYPES.MARGIN;
                        } else { }
                        break;
                    }
                }
            } else { }
        } else { }
        return strSelProduct;
    };

    const getT2PDetails = (strT2TSeriesList, strT2TScripErrorMsg) => {
        let isT2TSeriesScrip = false;
        if (strT2TSeriesList) {
            //T2T_SCRIP_ERROR_MESSAGE
            if (strT2TScripErrorMsg) {
                var T2TScripErrorMsg = strT2TScripErrorMsg.toString();
            }
            else {
                T2TScripErrorMsg = 'You are placing order in Trade to trade Scrip and Intraday square off is not allowed.';
            }
            let arrT2TSeriesList = [];

            arrT2TSeriesList = strT2TSeriesList.split('$');
            for (let i = 0; i < arrT2TSeriesList.length; i++) {
                let strSegment = arrT2TSeriesList[i];
                if (strSegment.split(':')[0].toString() == scripOrderInfo?.[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]?.toString()) {
                    let strSeries = '';
                    let arrSeries = [];
                    strSeries = strSegment.split(':')[1].toString();
                    if (strSeries != "") {
                        arrSeries = strSeries.split(',');

                        if (arrSeries.includes(scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES])) {
                            isT2TSeriesScrip = true;
                            break;
                        }
                    }
                }
            }
        } else { }
        return { isT2TSeriesScrip, T2TScripErrorMsg };
    };

    useEffect(() => {
        if (scripOrderInfo?.length > 0) {
            // On Init Scrip OrderInfo Setting
            // setToggleBracketOrder(curr => ({ ...curr, isShow: false }));
            setIsShowMarketDepth(false);
            setMarketDepthTab(scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
            {/* Vinit R : 12-03-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- Start */ }
            if (selectOrderOption?.isAmo || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTD || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT || orderInputs?.discQty) {//BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025
                setProfDesc(true);
            } else {
                setProfDesc(false);
            }
            {/* Vinit R : 12-03-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- End */ }

        } else { }
    }, [scripOrderInfo]);

    // const scripOrderInfoRef = useRef(scripOrderInfo);
    // const refScripPrice = useRef();

    // const setOnLoadScripPrice = useCallback(() => {
    //     if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
    //         if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.ASK_PRICE] > 0) {
    //             // refScripPrice.current.value = scripOrderInfo?.[WATCHLIST_GRID_INDEX.ASK_PRICE];
    //             handleOrderInputs({ target: { name: 'scripPrice', value: scripOrderInfo?.[WATCHLIST_GRID_INDEX.ASK_PRICE] } });
    //         } else {
    //             // refScripPrice.current.value = scripOrderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE];
    //             handleOrderInputs({ target: { name: 'scripPrice', value: scripOrderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] } });
    //         }
    //     } else {
    //         if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.BID_PRICE] > 0) {
    //             handleOrderInputs({ target: { name: 'scripPrice', value: scripOrderInfo?.[WATCHLIST_GRID_INDEX.BID_PRICE] } });
    //         } else {
    //             handleOrderInputs({ target: { name: 'scripPrice', value: scripOrderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] } });
    //         }
    //     }
    // }, [activeButtonToggleIndex, handleOrderInputs, scripOrderInfo, selectOrderOption]);


    // useEffect(() => {
    //     if (scripOrderInfo?.length > 0) {
    //         if (scripOrderInfoRef.current[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] != scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
    //             setOnLoadScripPrice();
    //         } else { }
    //     } else { }
    //     scripOrderInfoRef.current = scripOrderInfo;
    // }, [scripOrderInfo, orderInputs?.scripPrice, setOnLoadScripPrice]);
    // Vaibhav SIngh: BT-102298: 09-02-24:Issue for scrip decimal locator fixed:Start
    useEffect(() => {
        if (typeof orderInputs?.scripPrice === 'number') {
            handleOrderInputs({ target: { name: 'scripPrice', value: orderInputs?.scripPrice.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) } });
        }
    }, [orderInputs?.scripPrice]);
    // Vaibhav SIngh: BT-102298: 09-02-24:Issue for scrip decimal locator fixed:End
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
    const handleArrGridRowData = useCallback((arrDetails, liveFeedType) => {
        const objResp = _handleOrderEntryLiveData(arrDetails, arrScripExchanges, arrDistinctScripExchanges, liveFeedType);
        if (objResp?.status && objResp?.data?.length > 0) {
            const arrScripsExchangesLiveData = objResp?.data;
            setArrScripInformation([...arrScripsExchangesLiveData]);
            for (let i = 0; i < arrScripsExchangesLiveData.length; i++) {
                const arrScrip = arrScripsExchangesLiveData[i];
                if (scripOrderInfo?.length > 0 && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] == arrScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {

                    if (!isScripPrice && !isModifyOrder && !isReOrder) {//Azeem K :20-03-2024 :BT1-102298: BSEFO bug fixing :!isModifyOrder && !isReOrder condition added
                        handleOrderInputs({ target: { name: 'scripPrice', value: parseFloat(arrScrip[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]).toFixed(arrScrip[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) } });
                        //Maaz A : 09-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - LiveFeed Issue Fix - Start
                        setIsScripPrice(true);
                        //Maaz A : 09-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - LiveFeed Issue Fix - End
                    } else { }
                    setArrActiveScripInformation([...arrScrip]);
                    break;
                } else { }
            }
        } else { }
    }, [arrDistinctScripExchanges, arrScripExchanges, handleOrderInputs, isScripPrice, scripOrderInfo, setIsScripPrice]);
    //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End

    useEffect(() => {
        if (arrDistinctScripExchanges?.length > 0) {
            const arrDistinctScripExchangesSubscription = arrDistinctScripExchanges?.map(scrip => ({ exchangeId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true }));
            sendTouchlineRequest(arrDistinctScripExchangesSubscription);

            const objLastTickData = dispatch(getWfhTouchlineLastTick());
            arrDistinctScripExchanges.forEach(arrScrip => {
                const arrLastTickScripData = objLastTickData[arrScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
                if (arrLastTickScripData?.length > 0) {
                    //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
                    handleArrGridRowData([...arrLastTickScripData], 'touchline');
                    //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
                } else { }
            });

        } else { }

        return () => {
            const arrDistinctScripExchangesSubscription = arrDistinctScripExchanges?.map(scrip => ({ exchangeId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false }));
            sendTouchlineRequest(arrDistinctScripExchangesSubscription);
        };

    }, [arrDistinctScripExchanges]);

    useWFHMessages('touchline', (e) => {
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
        handleArrGridRowData([...e.detail], 'touchline');
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
    });

    //Maaz A : 07-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - Marketdepth live data not reflecting - End
    useWFHMessages('bestfive', (e) => {
        handleArrGridRowData([...e.detail], 'bestfive');
    });
    //Maaz A : 07-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - Marketdepth live data not reflecting - End

    useEffect(() => {
        const objResp = _getOrderEntryAllExchangeWiseProductTypes(productTypes, strSelectedExchName, objLoginSession);
        if (objResp?.status && objResp?.data?.length > 0) {
            setArrAllExchangeWiseProductTypes([...objResp?.data]);
        } else {
            setArrAllExchangeWiseProductTypes([]);
        }
    }, [objLoginSession, strSelectedExchName, productTypes]);


    useEffect(() => {
        if (arrScripInformation?.length > 0 && scripOrderInfo?.length > 0) {
            const nIndex = arrScripInformation?.findIndex(scrip => scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] == scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            if (nIndex >= 0) {
                setArrActiveScripInformation([...arrScripInformation[nIndex]]);
            } else {
                setArrActiveScripInformation([]);
            }
        } else { }
    }, [scripOrderInfo, arrScripInformation]);

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    const [bIsDPRError, setBIsDPRError] = useState({ scripPrice: false, slTrigger: false, intradayTrigger: false, intradayLimit: false, intradayProfit: false });
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

    const getValidateLTPPriceBand = useCallback(() => {
        let nTriggerPrice = parseFloat(orderInputs?.intradayTrigger);
        if (arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] && arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] > 0) {

            var nScripPrice = arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE];
        } else {
            nScripPrice = arrActiveScripInformation[WATCHLIST_GRID_INDEX.CLOSE];
        }

        if (selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES.SL)) {
            var nOrderPrice = parseFloat(orderInputs?.slTrigger);
        } else {
            nOrderPrice = parseFloat(orderInputs?.scripPrice);
        }
        //Azeem K : 02-02-2024: BT-114196 - Breeze - LTP based Price band Implementation  -MCX fixes -  Start
        const strOrderType = selectOrderOption?.orderType?.includes('SL') ? 'SL' : selectOrderOption?.orderType;
        //Azeem K : 02-02-2024: BT-114196 - Breeze - LTP based Price band Implementation  -MCX fixes -  End
        const objLtpValid = validateLTPPriceBand(scripOrderInfo, nScripPrice, activeButtonToggleIndex, nOrderPrice, strOrderType, ltpPriceBandMaster, nTriggerPrice);
        if (!objLtpValid?.valid) {
            if (objLtpValid?.isRestrictive) {
                dispatch(toastConfig({ show: true, backdrop: true, timer: alertTimeout, message: objLtpValid?.errorMsg, button: [{ btnName: "Ok", className: "btn btn-solid ms-3", type: 'CLOSE' }] }));
                dispatch(updateSingleScripOrderConfirmed(false));
                return false;
            } else {
                dispatch(toastConfig({
                    show: true, message: objLtpValid?.errorMsg, backdrop: true, button: [{
                        btnName: "Yes", className: "btn btn-solid ms-3", onClickHandler: () => {
                            if (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.MTF && objCFT?.PLEDGEUNPLEDGE && getAppInfoData(APP_INFO_PARAMS.APP_MTF_PREPLEDGE, appInfo) && activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                                if (isModifyOrder) {
                                    if (orderInputs?.scripQuantity > orderData?.totalQuantity) {
                                        let result = orderInputs?.scripQuantity - orderData?.totalQuantity;
                                        handleMTFPledgeRequest(result, appInfo, userId, objLoginSession, scripOrderInfo).then((res) => {
                                            if (res) dispatch(updateSingleScripOrderConfirmed(true));
                                        });
                                    } else {
                                        dispatch(updateSingleScripOrderConfirmed(true));
                                    }
                                } else {
                                    handleMTFPledgeRequest(orderInputs?.scripQuantity, appInfo, userId, objLoginSession, scripOrderInfo).then((res) => {
                                        if (res) dispatch(updateSingleScripOrderConfirmed(true));
                                    });
                                }
                            } else {
                                dispatch(updateSingleScripOrderConfirmed(true));
                                dispatch(toastConfig({ show: false }));
                            }
                        }
                    }, { btnName: "No", className: "btn btn-outline-active ms-3", type: 'CLOSE' }]
                }));
                return true;
            }
        } else {
            if (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.MTF && objCFT?.PLEDGEUNPLEDGE && getAppInfoData(APP_INFO_PARAMS.APP_MTF_PREPLEDGE, appInfo) && activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                if (isModifyOrder) {
                    if (orderInputs?.scripQuantity > orderData?.totalQuantity) {
                        let result = orderInputs?.scripQuantity - orderData?.totalQuantity;
                        handleMTFPledgeRequest(result, appInfo, userId, objLoginSession, scripOrderInfo).then((res) => {
                            if (res) dispatch(updateSingleScripOrderConfirmed(true));
                        });
                    } else {
                        dispatch(updateSingleScripOrderConfirmed(true));
                    }
                } else {
                    handleMTFPledgeRequest(orderInputs?.scripQuantity, appInfo, userId, objLoginSession, scripOrderInfo).then((res) => {
                        if (res) dispatch(updateSingleScripOrderConfirmed(true));
                    });
                }
            } else {
                dispatch(updateSingleScripOrderConfirmed(true));
                return true;
            }
        }
    }, [dispatch, ltpPriceBandMaster, activeButtonToggleIndex, arrActiveScripInformation, orderInputs, scripOrderInfo, selectOrderOption]);

    const survelienceConfirmationHandler = useCallback((nUserResp, scripInfo) => {
        dispatch(setCautionaryMessageFromPopup(nUserResp, scripInfo[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION], scripInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripInfo[WATCHLIST_GRID_INDEX.TOKEN]));
        dispatch(toastConfig({ show: false }));
        if (nUserResp === 1) {
            getValidateLTPPriceBand();
        } else {
            dispatch(updateSingleScripOrderConfirmed(false));
            dispatch(toastConfig({ show: false }));
        }
    }, [dispatch, getValidateLTPPriceBand]);

    //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
    const restrictInput = useCallback((e) => {
        const { name } = e.target;
        if (name === "quantity" || name === "scripQuantity" || name === "scripLot" || name === "discQty" || name === "scripAmount") {
            if (e.key === '.' || e.key === '-' || e.key === '+' || e.key?.toLowerCase() === 'e') {
                e.preventDefault();
            } else { }
            if (e.which === 38 || e.which === 40) {
                e.preventDefault();
                if (e.which === 38) {
                    handleOrderStepsOnChange(name, 'increase');
                } else if (e.which === 40) {
                    handleOrderStepsOnChange(name, 'decrease');
                }
            }
        } else { }
    }, [handleOrderStepsOnChange]);
    //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End

    const validatePriceForRange = useCallback(() => {
        try {
            const { intradayTrigger, intradayLimit, intradayProfit } = orderInputs;
            const { MPTriggerPriceLowRange, MPTriggerPriceHighRange, MPLimitPriceLowRange, MPLimitPriceHighRange, profitPriceLowRange, profitPriceHighRange } = bracketCoverOrderPriceRange;
            if (parseFloat(intradayTrigger) < parseFloat(MPTriggerPriceLowRange) || parseFloat(intradayTrigger) > parseFloat(MPTriggerPriceHighRange)) {
                dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Entered SL Trigger Price not in range: ' + MPTriggerPriceLowRange + '-' + MPTriggerPriceHighRange }));
                setBIsDPRError(curr => ({ ...curr, intradayTrigger: true }));
                return false;
            } else {
                setBIsDPRError(curr => ({ ...curr, intradayTrigger: false }));
            }

            if ((parseFloat(intradayLimit) < parseFloat(MPLimitPriceLowRange) || parseFloat(intradayLimit) > parseFloat(MPLimitPriceHighRange)) && parseFloat(intradayLimit) != 0) {
                dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Entered SL Limit Price not in range: ' + MPLimitPriceLowRange + '-' + MPLimitPriceHighRange }));
                setBIsDPRError(curr => ({ ...curr, intradayLimit: true }));
                return false;
            } else {
                setBIsDPRError(curr => ({ ...curr, intradayLimit: false }));
            }

            if ((parseFloat(intradayProfit) < parseFloat(profitPriceLowRange) || parseFloat(intradayProfit) > parseFloat(profitPriceHighRange)) && parseFloat(intradayProfit) != 0) {
                dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Entered Profit Price not in range: ' + profitPriceLowRange + '-' + profitPriceHighRange }));
                setBIsDPRError(curr => ({ ...curr, intradayProfit: true }));
                return false;
            } else {
                setBIsDPRError(curr => ({ ...curr, intradayProfit: false }));
            }

            return true;

        } catch (error) {
            console.error(error);
        }
    }, [bracketCoverOrderPriceRange, dispatch, orderInputs]);
    {/* Azeem K : 08-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - Start */ }
    //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - Start
    const bIsEqScripHaveLots = useMemo(() => (scripOrderInfo?.length && (scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_CASH || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_CASH || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.MSX_CASH) && scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT]?.toUpperCase() === SCRIP_INSTRUMENTS.EQUITIES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 1), [scripOrderInfo]);
    //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - End
    const [nMinDiscQty, setNMinDiscQty] = useState(0);
    const [nMinDiscLot, setNMinDiscLot] = useState(0);
    useEffect(() => {

        let discPerc = 0;
        if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.NSE_EQ_API || scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.BSE_EQ_API || scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.NSX_DERV_API || scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.BSECDX_DERV_API || scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.MCXSX_CURR_API || scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.NCDEX_DERV_API || scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.NCDEX_SPOT_API) {
            discPerc = 10;
        } else if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.MCX_DERV_API || scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.MCX_SPOT_API) {
            discPerc = 25;
        } else if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.MSE_EQ_API) {
            discPerc = 20;

        }
        //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - Start
        if (bIsEqScripHaveLots) {
            const miNQty = Math.ceil(orderInputs?.scripLot * discPerc / 100) * scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT];
            setNMinDiscQty(miNQty);
        } else {
            setNMinDiscQty(Math.ceil(orderInputs?.scripQuantity * discPerc / 100));
        }
        //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - End
        setNMinDiscLot(Math.ceil(orderInputs?.scripLot * discPerc / 100));
    }, [orderInputs, scripOrderInfo]);
    {/* Azeem K : 08-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - End */ }

    // Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start
    const bIsOCOAllowed = useMemo(() => {
        //BREEZE-4394 :LLD Creation :created memo for showing conditionally OCO checkbox 
        if (selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.SELL && (scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_CASH || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_CASH || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.MSX_CASH)) {
            handleOnSelectOrderOptionChange({ target: { name: 'isAmo', value: false } });

            return true;
        } else if (selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT &&
            (scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_DERIVATIVES || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSX_DERIVATIVES || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.MSX_DERIVATIVES || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSECDX_DERIVATIVES)) {
            handleOnSelectOrderOptionChange({ target: { name: 'isAmo', value: false } });
            return true;
        } else {
            handleOnSelectOrderOptionChange({ target: { name: 'isOCOChecked', value: false } });
            return false;
        }
    }, [selectOrderOption?.validityTypes, activeButtonToggleIndex, scripOrderInfo]);
    // Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End
    const orderConfirmValidations = useCallback(() => {
        try {
            // WIPP -> in Controller
            dispatch(updateSingleScripOrderConfirmed(false));
            //BT-138033 : Order Slicing: ManasaB : 26-06-2024 - Start
            let bIsBracketDataFilled = false;
            let bIsCoverDataFilled = false;
            setArrOrderSlicingInfo([]);
            //BT-138033 : Order Slicing: ManasaB : 26-06-2024 - End
            let { intradayTrigger, intradayLimit, scripPrice, slTrigger, intradayProfit, scripQuantity } = orderInputs;
            if (!isNaN(parseFloat(scripPrice)) && parseFloat(scripPrice) != 0 && parseFloat(MPLowPr) != 0 && parseFloat(MPHighPr) != 0) {
                if (parseFloat(MPLowPr) > parseFloat(scripPrice) || parseFloat(scripPrice) > parseFloat(MPHighPr)) {
                    setBIsDPRError(curr => ({ ...curr, scripPrice: true }));
                    //DPR validation- out of range indication in red color and Place Order button not disabled.
                } else {
                    setBIsDPRError(curr => ({ ...curr, scripPrice: false }));
                }
            }
            else {
                setBIsDPRError(curr => ({ ...curr, scripPrice: true }));
            }
            if (selectOrderOption?.orderType === ORDER_ENTRY_TYPES.SL || selectOrderOption?.orderType === ORDER_ENTRY_TYPES.SL_MKT) {
                if (!isNaN(parseFloat(slTrigger)) && parseFloat(slTrigger) != 0 && parseFloat(MPLowPr) != 0 && parseFloat(MPHighPr) != 0) {
                    if ((parseFloat(MPLowPr) > parseFloat(slTrigger) || parseFloat(slTrigger) > parseFloat(MPHighPr))) {
                        setBIsDPRError(curr => ({ ...curr, slTrigger: true }));
                        //return;//DPR validation- out of range indication in red color and Place Order button not disabled.
                    } else {
                        setBIsDPRError(curr => ({ ...curr, slTrigger: false }));
                    }
                }
                else {
                    setBIsDPRError(curr => ({ ...curr, slTrigger: true }));
                }
            } else { }
            // // <BT-90860> Rajendra Sirvi : Order Entry form Optimization <> Wave 2.0 {30/08/2022} {END}
            // discQuantityOnLostFocus();
            // if (!isNaN(parseFloat(discQuantityError)))
            //     return;

            const nMarketLot = scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT];
            const nMarketSegmentId = scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID];
            const nSelAmount = parseFloat(scripPrice) * nMarketLot;


            if ((bIsCoverOrderAllowed || bIsBracketOrderAllowed) && toggleBracketOrder?.isShow) {

                if (isNaN(parseFloat(intradayTrigger)) || parseFloat(intradayTrigger) == 0) {
                    setBIsDPRError(curr => ({ ...curr, intradayTrigger: true }));
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'SL Trigger Price must be provided.' }));
                    return false;
                } else { }

                if (isNaN(parseFloat(intradayLimit)) || parseFloat(intradayLimit) == 0) {
                    setBIsDPRError(curr => ({ ...curr, intradayLimit: true }));
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'SL Limit Price must be provided.' }));
                    return false;
                } else { }
                //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
                if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                    if (parseFloat(intradayTrigger) < parseFloat(intradayLimit)) {
                        setBIsDPRError(curr => ({ ...curr, intradayTrigger: true }));
                        dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.NNSL70 }));
                        return false;
                    } else { }
                }
                else//Sell side case
                {
                    if (parseFloat(intradayTrigger) > parseFloat(intradayLimit)) {
                        setBIsDPRError(curr => ({ ...curr, intradayTrigger: true }));
                        dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.NNSL72 }));
                        return false;
                    } else { }
                }
            }
            //  Azeem K : 08-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start 
            //    validatios will be added here as per user story
            //  Azeem K : 08-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End 
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
            // if (bIsBracketOrderAllowed && toggleBracketOrder?.isShow && toggleBracketOrder?.strProductType == ORDER_PRODUCT_TYPES.BRACKET) {
            //     if (isNaN(parseFloat(intradayProfit)) || parseFloat(intradayProfit) == 0) {
            //         setBIsDPRError(curr => ({ ...curr, intradayProfit: true }));
            //         dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Book Profit must be provided.' }));
            //         return false;
            //     } else {
            //         // setBIsDPRError(curr => ({ ...curr, intradayProfit: false }));
            //     }
            // } else {
            //     // setBIsDPRError(curr => ({ ...curr, intradayTrigger: false }));
            //     // setBIsDPRError(curr => ({ ...curr, intradayProfit: false }));
            // }

            if (selectOrderOption?.productType == ORDER_PRODUCT_TYPES.MTF || selectOrderOption?.productType == ORDER_PRODUCT_TYPES.BTST) {
                handleOnSelectOrderOptionChange({ target: { name: 'isAmo', value: false } });

            }

            if ((isNaN(parseInt(scripQuantity)) || parseInt(scripQuantity) == 0)) {
                if (selectOrderOption?.productType != ORDER_PRODUCT_TYPES.BRACKET) {
                    if (parseFloat(nSelAmount) < parseFloat(arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE])) {
                        dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Quantity was not provided/calculated.' }));
                        return false;
                    } else {
                        dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Quantity must be provided.' }));
                        return false;

                    }
                } else { }
            }
            if ((isNaN(parseFloat(scripPrice)) || parseFloat(scripPrice) == 0) && selectOrderOption?.orderType == ORDER_ENTRY_TYPES.RL) {
                dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Price must be provided.' }));
                return false;

            }
            if ((isNaN(parseFloat(slTrigger)) || parseFloat(slTrigger) == 0) && (selectOrderOption?.orderType == ORDER_ENTRY_TYPES.SL || selectOrderOption?.orderType == ORDER_ENTRY_TYPES.SL_MKT)) {
                dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Trigger Price must be provided.' }));
                return false;

            }


            if (selectOrderOption?.orderType == ORDER_ENTRY_TYPES.SL) {
                if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                    if (parseFloat(scripPrice) != 0 && parseFloat(slTrigger) > parseFloat(scripPrice)) {
                        dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.NNSL71 }));
                        return false;
                    }
                }
                /*  For SELL side order Trigger Price should be greater than Order Price for Product Type
                other than Margin Plus. For Margin Plus case is vice versa  
                Note: Case is viceversa only for fresh order
                For MarginPlus modification order use original normal formula TrigPr > OrderPrice */
                else {
                    //Sell side case
                    if (parseFloat(slTrigger) < parseFloat(scripPrice)) {
                        dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.NNSL73 }));
                        return false;

                    }
                }
            }

            //     //Issue solved for Normal equity order .by omprakash on 01 March 21
            if (nMarketLot != undefined && nMarketLot != "0") {
                //Norwin Dcruz 26/05/2022 To handle validation check for ncdex derivatives
                if (nMarketSegmentId == MARKET_SEGMENT_ID.NSE_DERIVATIVES || nMarketSegmentId == MARKET_SEGMENT_ID.NCDEX_DERIVATIVES
                    //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes - Start
                    || nMarketSegmentId == MARKET_SEGMENT_ID.BSE_DERIVATIVES
                    //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes - End
                    || ((nMarketSegmentId == MARKET_SEGMENT_ID.NSE_CASH || nMarketSegmentId == MARKET_SEGMENT_ID.BSE_CASH) && scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT].toUpperCase() == SCRIP_INSTRUMENTS.EQUITIES && nMarketLot > 1)) { // <BT-90860> Rajendra Sirvi : Order Entry form Optimization <> Wave 2.0 {30/08/2022}
                    if (parseInt(scripQuantity) % parseInt(nMarketLot) != 0) {
                        dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.NNSL46 + nMarketLot }));
                        return false;

                    }
                }
                // <BT-90860> Rajendra Sirvi : Order Entry form Optimization <> Wave 2.0 {30/08/2022} {START}
                //  BT-105190 BT-105191, NSE BSE Commodity Segment, Samadhan S, 18/04/2023 : Start
                if (nMarketSegmentId == MARKET_SEGMENT_ID.MCX_DERIVATIVES || nMarketSegmentId == MARKET_SEGMENT_ID.BSECDX_DERIVATIVES || nMarketSegmentId == MARKET_SEGMENT_ID.NSX_DERIVATIVES
                    || nMarketSegmentId == MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES || nMarketSegmentId == MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES) {// <BT-90860> Rajendra Sirvi : Order Entry form Optimization <> Wave 2.0 {30/08/2022}
                    //  BT-105190 BT-105191, NSE BSE Commodity Segment, Samadhan S, 18/04/2023 : End  
                    if (selectOrderOption?.orderBy == 'Quantity') {
                        if (parseInt(scripQuantity) % parseInt(nMarketLot) != 0) {
                            dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.NNSL46 + nMarketLot }));
                            return false;

                        }
                    }
                }
                // <BT-90860> Rajendra Sirvi : Order Entry form Optimization <> Wave 2.0 {30/08/2022} {END}
            }
            const nSelPriceTick = scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
            // const nSelPriceTick = scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] * MULTIPLIER.HUNDRED;
            const DecimalLocator = scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
            if (parseFloat(intradayTrigger) > 0 && parseFloat(intradayLimit) > 0) {
                bIsCoverDataFilled = true;  //BT-138033 : Order Slicing: ManasaB : 26-06-2024
            } else {
                bIsCoverDataFilled = false;
            }

            if (parseFloat(intradayTrigger) > 0 && parseFloat(intradayLimit) > 0 && parseFloat(intradayProfit) > 0) {
                bIsBracketDataFilled = true;  //BT-138033 : Order Slicing: ManasaB : 26-06-2024
            } else {
                bIsBracketDataFilled = false;
            }
            if (parseFloat(scripPrice) != 0) {

                const _AllowedDecimal = scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH];

                const nScripPrice = parseFloat(scripPrice);


                if (!(isValidDecimalDigits(nScripPrice.toString(), _AllowedDecimal))) {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.NNSL61 }));
                    return false;
                }


                const PriceinPaise = parseInt(Math.round(parseFloat((nScripPrice * DecimalLocator).toString())).toString());
                if (PriceinPaise % parseInt(nSelPriceTick) != 0 && !selectOrderOption?.orderType?.includes('MKT')) {
                    const PriceTickInRs = (parseFloat(nSelPriceTick) / DecimalLocator).toFixed(scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.NNSL62 + PriceTickInRs }));
                    return false;
                }
            }
            //     //Norwin Dcruz <30/05/2022> <TO handle validation issue>
            if (parseFloat(slTrigger) != 0) {
                let nScripPrice = parseFloat(slTrigger);
                let PriceinPaise = parseInt(Math.round(parseFloat((nScripPrice * DecimalLocator).toString())).toString());
                if (PriceinPaise % parseInt(nSelPriceTick) != 0) {
                    let PriceTickInRs = (parseFloat(nSelPriceTick) / DecimalLocator).toFixed(scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.NNSL359.replace('{0}', 'Trigger Price') + " " + PriceTickInRs }));
                    return false;
                }
            }
            if (selectOrderOption?.productType == ORDER_PRODUCT_TYPES.INTRADAY || selectOrderOption?.productType == ORDER_PRODUCT_TYPES.MARGIN) {
                //Azeem K :15-04-2025: will remove later --Start
                // if (!selectOrderOption?.orderType?.includes('MKT') && !bIsBracketDataFilled && bIsCoverDataFilled) {
                //     dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Cover order main leg should be market.' }));
                //     return false;
                // }
                //Azeem K :15-04-2025: will remove later -End

                if (bIsBracketDataFilled && selectOrderOption?.validityTypes != ORDER_VALIDITY.EOSESS && selectOrderOption?.validityTypes != ORDER_VALIDITY.DAY && selectOrderOption?.validityTypes != ORDER_VALIDITY.EOTODY) {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Day validity allowed for bracket order.' }));
                    return false;
                }
            }
            if (holdingsScrips?.length > 0) {
                //  Azeem K : 27-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSEEQ  - Start 

                var objScripHolding = holdingsScrips?.find(obj => {
                    const arrMarketsAvailable = obj?.OtherSegmentTokens?.split(',');
                    return arrMarketsAvailable?.includes(scripOrderInfo?.[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] + ':' + scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN])
                        || scripOrderInfo?.[WATCHLIST_GRID_INDEX.ISIN_CODE] === obj?.ISIN; //Azeem K 05-11-2024: added ISIN for finding holding.
                });
                //  Azeem K : 27-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSEEQ  - End 
                if (objScripHolding) {
                    var nOriginalHoldingQty = parseInt(objScripHolding?.TOTALFREEQUANTITY);
                } else {
                    nOriginalHoldingQty = 0;
                }
            } else {
                nOriginalHoldingQty = 0;
            }
            //Vaibhav Singh: 14-03-24: PTST Logic removed as discussed with mithun
            if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] == SCRIP_INSTRUMENTS.EQUITIES && activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.SELL && (selectOrderOption?.productType == ORDER_PRODUCT_TYPES.DELIVERY || selectOrderOption?.productType == ORDER_PRODUCT_TYPES.BTST || selectOrderOption?.productType == ORDER_PRODUCT_TYPES.PTST)) {
                {/* Azeem K : 05-04-2024 : BT-102298 - Breeze - Single Scrip Order entry -ShortSelling Validation on Modify Order - Start */ }
                // if (isModifyOrder && scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] == SCRIP_INSTRUMENTS.EQUITIES && activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.SELL && (selectOrderOption?.productType == ORDER_PRODUCT_TYPES.MTF || selectOrderOption?.productType == ORDER_PRODUCT_TYPES.BTST || selectOrderOption?.productType == ORDER_PRODUCT_TYPES.PTST)) {
                //     nOriginalHoldingQty = nOriginalQty;
                // }
                {/* Azeem K : 05-04-2024 : BT-102298 - Breeze - Single Scrip Order entry -ShortSelling Validation on Modify Order - End */ }
                {/* Azeem K : 09-05-2024 : BT-102298 - Breeze - Single Scrip Order entry -ShortSelling Validation on Modify Order - Start */ }
                if (isModifyOrder) {
                    //in case of modification of sell order, qty to be compare as (original order qty + TOTALFREEQUANTITY of holdings )
                    nOriginalHoldingQty = parseFloat(nOriginalQty) + parseFloat(nOriginalHoldingQty);
                }
                {/* Azeem K : 09-05-2024 : BT-102298 - Breeze - Single Scrip Order entry -ShortSelling Validation on Modify Order - End */ }
                if (parseInt(scripQuantity) > nOriginalHoldingQty) {
                    const strSelProductType = selectOrderOption?.productType;//Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry 
                    if (arrAllExchangeWiseProductTypes.length > 0) {
                        const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType == strSelProductType);//Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entr
                        if (objSelProductType) {
                            dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.APPSHORTSELL + ' ' + objSelProductType?.sDescription.toUpperCase() + '.' }));
                            return false;
                        } else { }
                    } else { }
                } else { }
            }
            //BT-135270 : Order Slicing: ManasaB : 26-06-2024 - Start
            //OrderSlicing
            if (Object.keys(objCFT).length > 0 && objCFT.ORDERSLICING === FACILITY_NUM.ON) {
                let exchangeName = JSON.parse(getDecryptLocalStorage('ORDER_SLICING_EXCHANGE'));
                if (!bIsBracketDataFilled && !bIsBracketDataFilled && !isModifyOrder) {
                    if (scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] == EXCHANGE_NAME_API.NSE_DERV_API && exchangeName?.[scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]] && (scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT].toUpperCase().substr(0, 3) == SCRIP_INSTRUMENTS.FUT || scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT].toUpperCase().substr(0, 3) == SCRIP_INSTRUMENTS.OPT) && (!Number(scripOrderInfo[WATCHLIST_GRID_INDEX.NSPREAD]))) {//BREEZE-16 :Order Slicing feature : ManasaB : 04-11-2024 :  SAT issue
                        if (selectOrderOption.productType == ORDER_PRODUCT_TYPES.INTRADAY || selectOrderOption.productType == ORDER_PRODUCT_TYPES.CARRYFORWARD) { //ManasaB : 27-09-2024 : Added product type
                            if (scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] != undefined && scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] != 0 && scripQuantity > scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY]) {
                                let nBalanceQty = scripQuantity % scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY];
                                let nMainQty = scripQuantity - nBalanceQty;
                                let nRemainQty = nMainQty / scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY];
                                // let arrSliceData = [];
                                // arrSliceData.push(`${nRemainQty} order(s) of ${scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] / scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT]} Lots (${scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY]} Qty)`);
                                setArrOrderSlicingInfo(prevArray => [...prevArray, `${nRemainQty} order(s) of ${scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] / scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT]} Lots (${scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY]} Qty)`]);
                                if (nBalanceQty > 0) {
                                    setArrOrderSlicingInfo(prevArray => [...prevArray, `1 order of ${nBalanceQty / scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT]} Lots (${nBalanceQty} Qty) `]);
                                }
                                // else {
                                //     let arrSlicingData = [...arrOrderSlicingInfo];
                                //     if (arrSlicingData.length == 0) {
                                //         arrTemp[0] = arrTemp[0] + 'will be placed.';
                                //         setArrOrderSlicingInfo([...arrTemp]);
                                //     }
                                //     else {
                                //         arrSlicingData[0] = arrSlicingData[0] + 'will be placed.';
                                //         setArrOrderSlicingInfo(arrSlicingData);
                                //     }

                                // }
                            }
                        }
                    }
                    //Vaibhav Singh BREEZE-3408 : BSEFAO logic for order slicing in order singlescrip
                    if (scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] == EXCHANGE_NAME_API.BSE_DERV_API && exchangeName?.[scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]] && (scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT]?.toUpperCase()?.substr(0, 3) == SCRIP_INSTRUMENTS.FUT || scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT]?.toUpperCase()?.substr(0, 3) == SCRIP_INSTRUMENTS.OPT) && (!Number(scripOrderInfo[WATCHLIST_GRID_INDEX.NSPREAD]))) {
                        if (selectOrderOption.productType == ORDER_PRODUCT_TYPES.INTRADAY || selectOrderOption.productType == ORDER_PRODUCT_TYPES.CARRYFORWARD) {
                            if (scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] != undefined && scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] != 0 && scripQuantity > scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY]) {
                                let nMainQty = scripQuantity - scripQuantity % scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY];;
                                let nRemainQty = nMainQty / scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY];
                                setArrOrderSlicingInfo(prevArray => [...prevArray, `${nRemainQty} order(s) of ${scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] / scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT]} Lots (${scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY]} Qty)`]);
                                if (scripQuantity % scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] > 0) {
                                    setArrOrderSlicingInfo(prevArray => [...prevArray, `1 order of ${scripQuantity % scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] / scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT]} Lots (${scripQuantity % scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY]} Qty) `]);
                                }
                            }
                        }
                    }
                }
            }
            //BT-135270 : Order Slicing: ManasaB : 26-06-2024 - End

            if (nGTDNoOfDays === 0 && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTD) {
                dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'GTD Date cannot be less than or equal to Current Date.' }));
                return false;
            }

            if ((selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES.SL)) && selectOrderOption?.validityTypes == ORDER_VALIDITY.IOC) {
                if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NSE_CASH || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NSE_DERIVATIVES
                    || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.BSE_CASH || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.MCX_DERIVATIVES || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.BSECDX_DERIVATIVES || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NSX_DERIVATIVES
                    || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES
                    || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.NNSL80 }));
                    return false;
                }
            }

            if (!isNaN(parseFloat(orderInputs?.protPercent)) && parseFloat(orderInputs?.protPercent) > 0 && parseFloat(orderInputs?.protPercent) > ORDER_ENTRY_CONSTANTS.PROTECTION_PERCENTAGE_MAX_RANGE) {
                dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: MSG_MASTER.OE66 }));
                return false;
            }

            {/* Azeem K : 03-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - Start */ }
            if (!isNaN(parseInt(orderInputs?.discQty)) && parseInt(orderInputs?.discQty) > 0) {
                if (bIsEqScripHaveLots && parseInt(orderInputs?.discQty) / scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] !== 0) {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: `Disclosed Qty must be multiple of lot size ${scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT]}` }));
                    return false;
                }
                else if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES && (parseInt(orderInputs?.discQty) > parseInt(orderInputs?.scripQuantity) || parseInt(orderInputs?.discQty) < nMinDiscQty)) {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: `Enter Disclosed Qty Between min ${nMinDiscQty + '-' + orderInputs?.scripQuantity}` }));
                    return false;
                } else if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] !== SCRIP_INSTRUMENTS.EQUITIES && (parseInt(orderInputs?.discQty) > parseInt(orderInputs?.scripLot) || parseInt(orderInputs?.discQty) < nMinDiscLot)) {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: `Enter Disclosed Lot Between min ${nMinDiscLot + '-' + orderInputs?.scripLot}` }));
                    return false;
                }
            }
            {/* Azeem K : 03-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - End */ }
            // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start
            // GTT OCO order validations
            if ((selectOrderOption?.isOCOChecked && bIsOCOAllowed)) {
                if (!orderInputs?.scripPrice || orderInputs?.scripPrice === '') {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Price cannot be blank' }));
                    return false;
                }
                else if (!orderInputs?.slTrigger || orderInputs?.slTrigger === '') {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Stop Loss Trigger Price cannot be blank' }));
                    return false;
                }
                else if (!orderInputs?.targetSelPrice || orderInputs?.targetSelPrice === '') {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Target Price cannot be blank' }));
                    return false;
                }
                else if (!orderInputs?.targetSelTriggerPrice || orderInputs?.targetSelTriggerPrice == '') {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Target Trigger Price cannot be blank' }));
                    return false;
                }
                else if ((isNaN(parseFloat(orderInputs?.targetSelPrice)) || parseFloat(orderInputs?.targetSelPrice) === 0)) {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Target Price must be provided' }));
                    return false;
                }
                else if ((isNaN(parseFloat(orderInputs?.targetSelTriggerPrice)) || parseFloat(orderInputs?.targetSelTriggerPrice) === 0)) {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Target Trigger Price must be provided' }));
                    return false;
                }
                if (activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                    if (parseFloat(orderInputs?.slTrigger) < (parseFloat(arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) || 0)) {
                        dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Stop Loss Trigger Price cannot be less than LTP' }));
                        return false;
                    }
                    else if (parseFloat(orderInputs?.targetSelTriggerPrice) > (parseFloat(arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) || 0)) {
                        dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Target Trigger Price cannot be more than LTP' }));
                        return false;
                    }
                }
                if (activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.SELL) {
                    if (parseFloat(orderInputs?.slTrigger) > (parseFloat(arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) || 0)) {
                        dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Stop Loss Trigger Price cannot be more than LTP' }));
                        return false;
                    }
                    else if (parseFloat(orderInputs?.targetSelTriggerPrice) < (parseFloat(arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) || 0)) {
                        dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Target Trigger Price cannot be less than LTP' }));
                        return false;
                    }
                }
                if (parseFloat(orderInputs?.targetSelPrice) === (parseFloat(arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) || 0)) {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Stop Loss Trigger Price cannot be same to LTP' }));
                    return false;
                }
                if (parseFloat(orderInputs?.targetSelTriggerPrice) === (parseFloat(arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) || 0)) {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Target Trigger Price cannot be same to LTP' }));
                    return false;
                }
                if (parseFloat(orderInputs?.targetSelPrice) === parseFloat(orderInputs?.targetSelTriggerPrice)) {
                    dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'Stop Loss Trigger Price and Target Trigger Price cannot be same' }));
                    return false;
                }
            }
            // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End

            // Show Survilience alert
            if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]) {
                const strMsg = getGSMGradeDescriptionFromScrip(scripOrderInfo);
                if (strMsg) {
                    dispatch(toastConfig({ show: true, message: strMsg, button: [{ btnName: "Yes", className: "btn btn-solid ms-3", onClickHandler: (e) => survelienceConfirmationHandler(SURV_MEASURE_POPUP_ACTION.YES, scripOrderInfo) }, { btnName: "No", className: "btn btn-outline-active ms-3", onClickHandler: () => survelienceConfirmationHandler(SURV_MEASURE_POPUP_ACTION.NO, scripOrderInfo) }] }));
                    return false;
                } else { }
            } else {
                return getValidateLTPPriceBand();
            }
            dispatch(updateSingleScripOrderConfirmed(true));
            return true;

        } catch (error) {
            console.error(error);
        }

    }, [MPHighPr, MPLowPr, activeButtonToggleIndex, arrActiveScripInformation, getValidateLTPPriceBand, nGTDNoOfDays,
        arrAllExchangeWiseProductTypes, bIsBracketOrderAllowed, bIsCoverOrderAllowed, survelienceConfirmationHandler,
        dispatch, holdingsScrips, orderInputs, scripOrderInfo, selectOrderOption, toggleBracketOrder, validatePriceForRange, bIsOCOAllowed]);
    // Ajitesh : 06/12/2023: BT-109135: Breeze eDIS implementation - Start
    const checkForEdisValidation = () => {
        const isPOAUser = hasUserGrantedPOA();
        if (!isPOAUser &&
            scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES &&
            activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.SELL &&
            (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.DELIVERY || selectOrderOption?.productType === ORDER_PRODUCT_TYPES.AMO_DELIVERY || selectOrderOption?.productType === ORDER_PRODUCT_TYPES.MTF)
        ) {
            // Validation block for non AMO orders
            if (!selectOrderOption?.isAmo) {
                // If order qty < edisCheckQty all qty is authorised then no edis required
                if (scripSummary.length === 0 ||
                    Number(orderInputs.scripQuantity) <= scripSummary[0].eDISCheckQty ||
                    scripSummary[0].eDISRequestQty === 0 ||
                    (isModifyOrder && Number(orderInputs.scripQuantity) <= orderData?.totalQuantity + scripSummary[0].eDISCheckQty)
                ) {
                    return false;
                }
                // else edis required
                else {
                    return true;
                }
            }
            // Validation block for AMO SELL orders
            else {
                // Check if response from AMO auth exists in redux
                if (amoScripDetailsForValidation.length) {
                    // if qty to sell < qty approved in most recent edis auth response and user is not changing scrip in order entry then no need of edis
                    if (Number(orderInputs.scripQuantity) <= amoScripDetailsForValidation[0].Qty && scripSummary[0].sISINCode === scripOrderInfo?.[WATCHLIST_GRID_INDEX.ISIN_CODE]) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                // If response from AMO auth does not exist in redux and fresh AMO being done
                else {
                    return true;
                }
            }
        }
        return false;
    };
    // Ajitesh : 06/12/2023: BT-109135: Breeze eDIS implementation - End

    //const orderData = useSelector(state => state.modals?.modalData?.orderData);

    function getOrderValue(orderInputs, scripOrderInfo) {
        let orderVal = 0;
        {/* Azeem K : 23-01-2024 : BT-102298 NSECDS Netposition –--Start */ }
        let price = parseFloat(orderInputs?.scripPrice);
        {/* Azeem K : 23-01-2024 : BT-102298 NSECDS Netposition –--End */ }
        let selQty = scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? orderInputs?.scripQuantity : orderInputs?.scripLot;
        if ((!isNaN(price)) && selQty != '') {
            switch (scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]) {
                case MARKET_SEGMENT_ID.NSE_CASH:
                case MARKET_SEGMENT_ID.BSE_CASH:
                case MARKET_SEGMENT_ID.BSE_DERIVATIVES:
                case MARKET_SEGMENT_ID.NSE_DERIVATIVES:
                case MARKET_SEGMENT_ID.MSX_CASH:
                case MARKET_SEGMENT_ID.OFS_IPO_BONDS:
                    orderVal = price * parseInt(selQty);
                    break;

                case MARKET_SEGMENT_ID.MCX_DERIVATIVES:
                case MARKET_SEGMENT_ID.ICEX_DERIVATIVES:
                case MARKET_SEGMENT_ID.MSX_DERIVATIVES:
                case MARKET_SEGMENT_ID.NSX_DERIVATIVES:
                case MARKET_SEGMENT_ID.BSECDX_DERIVATIVES:
                case MARKET_SEGMENT_ID.NSEL_DERIVATIVES:
                case MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES:
                case MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES:
                    /**** FORMULA: OrderValue= OrderLot * Price * ((Numerator/Denominator) * (GenNumerator/GenDenominator)) * RegularLotSize ****/
                    orderVal = price * selQty * ((parseFloat(scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_NUMERATOR]) / parseFloat(scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_DENOMINATOR]))
                        * (parseFloat(scripOrderInfo?.[WATCHLIST_GRID_INDEX.AVM_BUY_MARGIN]) / parseFloat(scripOrderInfo?.[WATCHLIST_GRID_INDEX.AVM_SELL_MARGIN]))) * scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT];
                    break;

                case MARKET_SEGMENT_ID.MSX_FAO:
                    /**** FORMULA: OrderValue= OrderLot * Price * RegularLotSize ****/
                    orderVal = price * selQty * scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT];
                    break;

                case MARKET_SEGMENT_ID.NCDEX_DERIVATIVES:
                    /**** FORMULA: OrderValue= OrderQty * Price * (Numerator/Denominator) ****/
                    orderVal = price * selQty * scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] * (parseFloat(scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_NUMERATOR]) / parseFloat(scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_DENOMINATOR]));
                    break;

                default: break;
            }
        }
        return parseFloat(orderVal.toFixed(2));//
    }

    // Ajitesh : 30/03/2024 - Function to directly take user to CDSL/NSDL in case of AMO order and edis validaiton
    const payloadDetailsForEdis = () => {
        let isMultiIsinEnabled = getAppInfoData(APP_INFO_PARAMS.APP_MULTI_ISIN_NSDL, appInfo);
        let url = getAppInfoData(APP_INFO_PARAMS.APP_EDIS_REQUEST_NEWNETNET_URL, appInfo);
        const scripDataFromEdisApi = edisSummaryDetails?.edis_summary.filter(scrip => scrip.sISINCode === scripOrderInfo?.[WATCHLIST_GRID_INDEX.ISIN_CODE]);
        const scripSummary = scripDataFromEdisApi.length ? [{
            sSecurityDesc: scripDataFromEdisApi[0].sSecurityDesc,
            authorizedQty: {
                ApprovedQuantity: scripDataFromEdisApi[0].ApprovedQuantity,
                eDISDPQty: scripDataFromEdisApi[0].eDISDPQty
            },
            eDISRequestQty: Number(orderInputs?.scripQuantity),
            nSettlementType: "T+1 (Next Day)",
            ApprovedQuantity: scripDataFromEdisApi[0].ApprovedQuantity,
            eDISDPQty: scripDataFromEdisApi[0].eDISDPQty,
            TodayFreeQty: scripDataFromEdisApi[0].TodayFreeQty,
            ClosePrice: scripDataFromEdisApi[0].ClosePrice,
            sISINCode: scripDataFromEdisApi[0].sISINCode,
            eDISCheckQty: scripDataFromEdisApi[0].eDISCheckQty,
        }] : [];

        let dpDetailsEdis = null;
        let dataPayloadEdis = null;
        dpDetailsEdis = {
            ...userDpDetails.data,
            "ISIN": scripOrderInfo?.[WATCHLIST_GRID_INDEX.ISIN_CODE] || "",
            "edisRequestQty": Number(orderInputs?.scripQuantity),
            "securityDescription": scripOrderInfo?.[WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION] || ''
        };
        if (scripSummary.length > 0) {
            dataPayloadEdis = {
                dpDetails: { ...dpDetailsEdis },
                exchangeName: exchgAndMktSegData.exchangeName,
                instrumentType: scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT],
                marketSegmentId: exchgAndMktSegData.marketSegmentId,
                scripsData: [...scripSummary],
                productType: selectOrderOption?.productType,
                isAmo: selectOrderOption?.isAmo,
                selectedSettlement: "T+1 (Next Day)",
                isMultiIsin: isMultiIsinEnabled,
                edisURL: url
            };
        }
        return dataPayloadEdis;
    };

    // Ajitesh 13/06/2024 - Extracts part of handleConfirmModal code in this new function which can be passed as prop to EDIS to show order confirmation modal on successfull edis authentication
    const showOrderConfirmModal = () => {
        const nOrderValue = getOrderValue(orderInputs, scripOrderInfo);
        dispatch(handleModalData({
            data: {
                layoutType: LAYOUT_TYPE.HORIZONTAL, activeButtonToggleIndex, orderEntryTab: ORDER_TYPES.SINGLE_SCRIP, activeTabKey: '', GTDNoOfDays: nGTDNoOfDays,
                scripOrderInfo, selectOrderOption, orderInputs, nOrderValue, bIsCoverBracketOrderOpen: toggleBracketOrder?.isShow, objSelectOrderOptionInit,
                isModifyOrder: isModifyOrder, orderData: orderData, isReOrder: isReOrder,
                arrOrderSlicingInfo: arrOrderSlicingInfo  //BT-138033 : Order Slicing: ManasaB : 26-06-2024 
                , GTTValidDate: GTTValidDate//BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025
            }
        }));
        dispatch(updateSingleScripOrderConfirmed(false));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': false }, { 'ORDER_ENTRY_CONFIRMATION': true }], true));
    };
    // Ajitesh 13/06/2024 - Extracts part of handleConfirmModal code in this new function which can be passed as prop to EDIS to show order confirmation modal on successfull edis authentication

    const handleConfirmModal = async () => {
        // Ajitesh : 06/12/2023: BT-109135: Breeze eDIS implementation - Start
        const edisFlowRequired = checkForEdisValidation();
        if (edisFlowRequired) {
            dispatch(updateSingleScripOrderConfirmed(false));
            // Deepti B. As per the requirement changes, we need to show edis grid despite of AMO order , hence commented the AMO condition which directly navigate to external url
            // Adding block here that does not take to grid but directly to external URL for AMO eDIS
            // if (selectOrderOption?.isAmo) {
            //     const dataPayload = payloadDetailsForEdis();
            //     _executeEdisOnline(dataPayload).then((response) => {
            //         handleResponseForAmoSell(response);
            //     });
            // }
            // else {
            dispatch(handleModal([{ "EDIS_PERMISSION_MODAL_SINGLE_ORDER": true }], true));
            // }
        }
        else {
            // const nOrderValue = orderInputs.scripQuantity * orderInputs.scripPrice;
            // Ajitesh - 13/06/2024 call confirm modal if all validations pass and edis not required
            showOrderConfirmModal();
        }
    };

    const getEvent = useAnalyticsEventTracker('Order Entry Single Scrip');

    const handlePlaceOrderButton = useCallback((e) => {
        getEvent('Place Order');
        e?.preventDefault();
        if (!bIsPlaceOrderBtnDisabled) {
            orderConfirmValidations();
        }
    }, [bIsPlaceOrderBtnDisabled, orderConfirmValidations]); // Ameersha N --31-03-2024 Dependency shoudl not to be removed

    const handleClose = useCallback(() => {
        dispatch(handleModal([{ "EDIS_PERMISSION_MODAL_SINGLE_ORDER": false }], true));
        dispatch(toastConfig({}));
        //setDataRefreshed(true);
    }, [dispatch]);

    useEffect(() => {
        if (isOrderConfirmed && layoutType == LAYOUT_TYPE.HORIZONTAL) {
            handleConfirmModal();
        }
        //Breeze-16 : Order slicing feature :ManasaB : 10-10-2024 - Side tray order entry slicing - Start
        else if (isOrderConfirmed && layoutType == LAYOUT_TYPE.VERTICAL) {
            dispatch(handleModalData({
                data: {
                    arrOrderSlicingInfo: arrOrderSlicingInfo  //BT-138033 : Order Slicing: ManasaB : 26-06-2024 
                    , GTTValidDate: GTTValidDate//BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025
                }
            }));
        }
        //Breeze-16 : Order slicing feature :ManasaB : 10-10-2024 - Side tray order entry slicing - End
    }, [isOrderConfirmed, layoutType]);

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    const BrokerageChargesModal = () => {
        dispatch(handleModal([{ 'BROKERAGE_CHARGES_MODAL': true }]));
    };

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start


    const onMarketChange = (selectedExchangeScrip) => {
        if (isModifyOrder) {
            // Maaz A - For Modify Order Market Change is Disabled
            return;
        } else {
            setIsScripPrice(false);
            setToggleBracketOrder(curr => ({ ...curr, isShow: false, strProductType: ORDER_PRODUCT_TYPES.COVER }));
            dispatch(getScripOrderInfo({ isBuySell: activeButtonToggleIndex, activeExchangeId: selectedExchangeScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: selectedExchangeScrip, bIsHoldingsSell: bIsHoldingsSell }));
        }
    };


    const objCoverBracketMarginPayload = useMemo(() => {
        if (scripOrderInfo?.length > 0) {
            return {
                mktSegmentId: scripOrderInfo?.[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                nToken: scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN],
                strInstName: scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT],
                strSymbol: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL],
                strSeries: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] : '-',
                strExpDate: scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXPIRYDATE] ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXPIRYDATE] : 'NA',
                strStrikePrice: scripOrderInfo?.[WATCHLIST_GRID_INDEX.STRIKEPRICE] ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.STRIKEPRICE] : '-',
                strOptionType: scripOrderInfo?.[WATCHLIST_GRID_INDEX.OPTIONTYPE] ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.OPTIONTYPE] : 'NA',
                strProductTypeCode: getProductTypeValue(ORDER_PRODUCT_TYPES.BRACKET),
            };
        } else {
            return {};
        }
    }, [scripOrderInfo]);

    const handleCoverOrderMargins = async (objPayload, bToggleCoverOrder = false) => {
        objPayload.strProductTypeCode = getProductTypeValue(ORDER_PRODUCT_TYPES.COVER);
        const arrCoverResp = await dispatch(getMarginPlusParams(objPayload));
        if (arrCoverResp?.length > 0) {

            if (arrCoverResp[0]?.nIsMatching == 1) {
                fnComputeMPRange(arrCoverResp[0], arrActiveScripInformation);
                return true;
            } else {
                dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'COVER order not allowed for this scrip.' }));
            }

        } else {
            dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'COVER order not allowed for this scrip.' }));
        }
        return false;
    };

    const handleBracketOrderMargins = async (objPayload, bToggleBracketOrder = false) => {

        const arrBracketResp = await dispatch(getMarginPlusParams(objPayload));
        if (arrBracketResp?.length > 0) {
            if (arrBracketResp[0]?.nIsMatching == 1) {
                fnComputeMPRange(arrBracketResp[0], arrActiveScripInformation);
                return true;
            } else {
            }
        } else {
            dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'COVER order not allowed for this scrip.' }));
        }
        return false;
    };

    const onClickCoverBracketOrder = async () => {
        if (toggleBracketOrder?.isShow) {
            setToggleBracketOrder(curr => ({ ...curr, isShow: !curr.isShow, strProductType: ORDER_PRODUCT_TYPES.COVER }));
        } else {
            if (bIsBracketOrderAllowed) {
                // Show Bracket order
                objCoverBracketMarginPayload.strProductTypeCode = getProductTypeValue(ORDER_PRODUCT_TYPES.BRACKET);
                const bToggleBracketOrder = await handleBracketOrderMargins(objCoverBracketMarginPayload);
                if (bToggleBracketOrder) {
                    setToggleBracketOrder(curr => ({ ...curr, isShow: !curr.isShow, strProductType: ORDER_PRODUCT_TYPES.BRACKET }));
                } else {
                    objCoverBracketMarginPayload.strProductTypeCode = getProductTypeValue(ORDER_PRODUCT_TYPES.COVER);
                    const bToggleCoverOrder = await handleCoverOrderMargins(objCoverBracketMarginPayload);
                    if (bToggleCoverOrder) {
                        setToggleBracketOrder(curr => ({ ...curr, isShow: !curr.isShow, strProductType: ORDER_PRODUCT_TYPES.COVER }));
                    } else { }

                }
            } else if (bIsCoverOrderAllowed) {
                // Show Cover order
                objCoverBracketMarginPayload.strProductTypeCode = getProductTypeValue(ORDER_PRODUCT_TYPES.COVER);
                const bToggleCoverOrder = await handleCoverOrderMargins(objCoverBracketMarginPayload);
                if (bToggleCoverOrder) {
                    setToggleBracketOrder(curr => ({ ...curr, isShow: !curr.isShow, strProductType: ORDER_PRODUCT_TYPES.COVER }));
                } else { }
            } else {
                dispatch(toastConfig({ autoDismiss: true, timer: alertTimeout, show: true, message: 'COVER order not allowed for this scrip.' }));
            }
        }
    };

    useEffect(() => {

        if (activeButtonToggleIndex >= 0 && scripOrderInfo?.length > 0 && toggleBracketOrder?.isShow) {
            if (bIsBracketOrderAllowed) {
                // Show Bracket order
                handleBracketOrderMargins(objCoverBracketMarginPayload, false);
            } else if (bIsCoverOrderAllowed) {
                // Show Cover order
                handleCoverOrderMargins(objCoverBracketMarginPayload, false);
            }
        } else { }

    }, [activeButtonToggleIndex, scripOrderInfo, bIsBracketOrderAllowed, bIsCoverOrderAllowed]);

    const onFocusOutInput = useCallback((e) => {
        const { name, value } = e.target;
        if (name === 'protPercent') {
            if (value) {
                handleOrderInputs({ target: { name, value: parseFloat(value).toFixed(2) } });
            }
        } else if (value) {
            handleOrderInputs({ target: { name, value: parseFloat(value).toFixed(scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) } });
        } else { }

    }, [scripOrderInfo, handleOrderInputs]);

    const fnComputeMPRange = (objOrderMarginParams, arrActiveScripLiveData) => {
        const { status, data } = _orderEntryComputeMPRange(objOrderMarginParams, arrActiveScripLiveData, scripOrderInfo, MPHighPr, MPLowPr);
        if (status && data.length > 0) {
            const [MPActualHighPr, MPActualLowPr] = data;
            if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                const { status, data: objRanges } = _orderEntryComputeBuySideMPPriceRange(objOrderMarginParams, arrActiveScripLiveData, MPActualHighPr, MPActualLowPr, orderInputs, scripOrderInfo);
                if (status) {
                    setBracketCoverOrderPriceRange({
                        MPTriggerPriceLowRange: objRanges?.MPTriggerPriceLowRange, MPTriggerPriceHighRange: objRanges?.MPTriggerPriceHighRange,
                        MPLimitPriceLowRange: objRanges?.MPLimitPriceLowRange, MPLimitPriceHighRange: objRanges?.MPLimitPriceHighRange,
                        profitPriceLowRange: objRanges?.profitPriceLowRange, profitPriceHighRange: objRanges?.profitPriceHighRange
                    });
                } else {
                    setBracketCoverOrderPriceRange({
                        MPTriggerPriceLowRange: 0, MPTriggerPriceHighRange: 0,
                        MPLimitPriceLowRange: 0, MPLimitPriceHighRange: 0,
                        profitPriceLowRange: 0, profitPriceHighRange: 0
                    });
                }
            }
            else {
                const { status, data: objRanges } = _orderEntryComputeSellSideMPPriceRange(objOrderMarginParams, arrActiveScripLiveData, MPActualHighPr, MPActualLowPr, orderInputs, scripOrderInfo);
                if (status) {
                    setBracketCoverOrderPriceRange({
                        MPTriggerPriceLowRange: objRanges?.MPTriggerPriceLowRange, MPTriggerPriceHighRange: objRanges?.MPTriggerPriceHighRange,
                        MPLimitPriceLowRange: objRanges?.MPLimitPriceLowRange, MPLimitPriceHighRange: objRanges?.MPLimitPriceHighRange,
                        profitPriceLowRange: objRanges?.profitPriceLowRange, profitPriceHighRange: objRanges?.profitPriceHighRange
                    });
                } else {
                    setBracketCoverOrderPriceRange({
                        MPTriggerPriceLowRange: 0, MPTriggerPriceHighRange: 0,
                        MPLimitPriceLowRange: 0, MPLimitPriceHighRange: 0,
                        profitPriceLowRange: 0, profitPriceHighRange: 0
                    });
                }
            }
        } else { }
    };

    useImperativeHandle(ref, () => ({
        handlePlaceOrderButton,
    }));

    const strSelectedInputName = useMemo(() => {
        if (selectOrderOption?.orderBy === 'Lot') {
            return 'scripLot';
        } else if (selectOrderOption?.orderBy === 'Quantity') {
            return 'scripQuantity';
        } else {
            return 'scripAmount';
        }
    }, [selectOrderOption]);

    const handleSelectScripFromInlineSearch = (arrScrip) => {
        // Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders Start
        if (arrScrip[WATCHLIST_GRID_INDEX.NSPREAD] === 1) {
            var spreadPaylod =
            {
                "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(arrScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API
                "symbol": arrScrip[WATCHLIST_GRID_INDEX.SYMBOL],
                "token": arrScrip[WATCHLIST_GRID_INDEX.TOKEN]
            };
            dispatch(getSpreadOrder(spreadPaylod));
            dispatch(getScripOrderInfo({ activeExchangeId: arrScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: arrScrip }));
            dispatch(handleModalData({ data: { spreadArr: arrScrip, orderEntryTab: 'multi_scrip', activeTabKey: 'spread' } }), true);
            // Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders End

        } else {
            dispatch(updateResetScrip(true));
            dispatch(getScripOrderInfo({ isBuySell: activeButtonToggleIndex, activeExchangeId: arrScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: arrScrip }));
            setSelectOrderOption(curr => ({ ...curr, isDefaultProductType: true, orderType: ORDER_ENTRY_TYPES.RL }));// Azeem K:29-02-2024:BT_102298:MCX if user change scrip from inlineSearch default product type should open
            setOrderInputs(curr => ({ ...curr, scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, discQty: 0, targetSelPrice: 0, targetSelTriggerPrice: 0 }));// Azeem K:29-02-2024:BT_102298:MCX if user change scrip from inlineSearch default product type should open
        }
        // isScripPrice = false;
        setIsScripPrice(false);
        setInputSearch(false);
        setTimeout(() => {
            const searchIconButton = document.getElementById('searchIcon');
            if (searchIconButton) {
                searchIconButton?.focus();
            }
        }, 10);

    };

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    //Maaz A : 10-10-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD Order - Start
    const onDateChange = useCallback((date, dateString) => {
        handleOrderInputs({ target: { name: 'gtdDate', value: date } });
    }, []);

    const disabledDate = useCallback(current => {
        // Calculate the date 90 days from today
        const gTDMaxDays = moment().add(scripOrderInfo?.length && scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES ? GTD_DAYS_FOR_NCDEX.MAX_DAYS : objLoginSession?.data?.others?.nGTDMaxDays, 'days');

        // If the current date is after 90 days from now, disable it
        return current && (current > gTDMaxDays || current < dayjs().endOf('day'));
    }, [objLoginSession?.data?.others?.nGTDMaxDays, scripOrderInfo]);
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 - Start
    //  for showing diffrent  "valid till" text  below validity dropdown  for EQ and othe segments 
    const GTTValidDate = useMemo(() => {

        let GTTNoOfDays = parseInt(objLoginSession?.data?.others.nGTDMaxDays.toString());
        let GTTDate = new Date();
        if (!isModifyOrder && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT) {
            if (scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE] == '') {
                GTTDate = moment(GTTDate).add(GTTNoOfDays, 'days').format('DD MMM YYYY');
            }
            else {
                let ValidExpireDays = CalculateDays(GTTDate, new Date(scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
                if (GTTNoOfDays >= ValidExpireDays) {
                    GTTDate = new Date(scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE].toUpperCase());
                }
                else {
                    GTTDate = moment(GTTDate).add(GTTNoOfDays, 'days');
                }
            }
        }
        else if (orderData && isModifyOrder && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT) {
            if (parseInt(orderData?.validity_days) > 0) {

                GTTDate = moment(GTTDate).add(orderData?.validity_days, 'days');
            }
            else {
                GTTDate = "";
            }
        } else {
            GTTDate = "";
        }
        if (GTTDate) {
            GTTDate = moment(GTTDate)?.format("DD MMM 'YY");
        } else { }

        return GTTDate;
    }, [objLoginSession?.data?.others.nGTDMaxDays, scripOrderInfo, isModifyOrder, selectOrderOption?.validityTypes, orderData]);
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 - End

    // Maaz A : 10-10-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD Order - End

    //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    useEffect(() => {
        const clickFunction = (event) => {
            if (inputSearch) {
                if (!inlineSearchRef?.current?.contains(event.target) && !event.target.matches('.inline-search-wrap ,.inline-search-scrip-list, .inline-search-scrip-list *')) {
                    setInputSearch(false);
                    setTimeout(() => {
                        const searchIconButton = document.getElementById('searchIcon');
                        if (searchIconButton) {
                            searchIconButton?.focus();
                        }
                    }, 10);
                } else { }
            } else { }
        };
        document.addEventListener('mousedown', clickFunction);
        return () => {
            document.removeEventListener('mousedown', clickFunction);
        };
    }, [inputSearch]);

    //Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
    const onPriceInputsKeyDown = (e) => {
        const { name } = e.target;
        if (
            //Azeem K : 06-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX Fixes - Start
            (e.key === '-' && name !== 'scripPrice' && name !== 'slTrigger') ||
            //Azeem K : 06-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX Fixes - End
            e.key === '+' || e.key.toLowerCase() === 'e') {
            e.preventDefault();
        } else {
            if (e.which === 38 || e.which === 40) {
                e.preventDefault();
                if (e.which === 38) {
                    handleOrderStepsOnChange(name, 'increase');
                } else if (e.which === 40) {
                    handleOrderStepsOnChange(name, 'decrease');
                } else { }
            }
        }
    };

    const handleScripOverview = () => {
        dispatch(setScripOverviewData(scripOrderInfo));
        dispatch(updateScripAndOptionData({ instrumentName: scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT], symbol: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL], instrument: scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT], id: scripOrderInfo?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID], token: scripOrderInfo?.[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN] : scripOrderInfo?.[WATCHLIST_GRID_INDEX.ASSET_TOKEN], bestFive: true, location: OPTION_CHAIN.OVERVIEW }));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }, { 'ORDER_ENTRY_MODAL': false }], true));
        dispatch(handleModalData({ tab: 'overview' }));
        if (layoutType === LAYOUT_TYPE.VERTICAL) {
            setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; }); //Azeem K :25-11-2024 :cloe side tray on click of overview
        }
    };
    //Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
    //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    //Maaz A : 08-12-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - Start
    const isGTDDropdown = useMemo(() => {
        return selectOrderOption?.validityTypes === ORDER_VALIDITY.GTD && selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.RL_MKT;
    }, [selectOrderOption?.validityTypes, selectOrderOption?.orderType]);
    //Maaz A : 08-12-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - End


    // Shuaib P. limit price input prefilled --start
    useEffect(() => {
        if (orderInputs.scripPrice !== '' || orderInputs.scripPrice !== '0.00') {
            setIsScripPrice(false);
        }
    }, []);
    // Shuaib P. limit price input prefilled --end

    // Ajitesh 19/03/2024 Logic to handle eDIS response from window obj for AMO sell
    const handleResponseForAmoSell = (response) => {
        // check if AMO SELL scrip is present in response
        setAmoScripDetailsForValidation(response.filter(item => item.ISIN === scripOrderInfo?.[WATCHLIST_GRID_INDEX.ISIN_CODE]));
        showOrderConfirmModal();
    };


    const strValidityMessage = useMemo(() => {
        if (selectOrderOption?.validityTypes === ORDER_VALIDITY.DAY) {
            return 'DAY orders placed are valid till the end of trading session for the day';
        } else if (selectOrderOption?.validityTypes === ORDER_VALIDITY.IOC) {
            return 'Immediate Or Cancel(IOC) orders placed will be executed immediately or cancelled';
        } else if (selectOrderOption?.validityTypes === ORDER_VALIDITY.GTD) {
            return 'Good Till Date(GTD) orders placed are valid till the date you have mentioned in the next field';
        } else if (selectOrderOption?.validityTypes === ORDER_VALIDITY.EOSESS) {
            return 'EOSESS orders placed are valid till end of session and will expire at 3:30pm once the market closes';
        } else if (selectOrderOption?.validityTypes === ORDER_VALIDITY.EOTODY) {
            return 'EOTODY orders placed are valid till the end of trading session for the day';
        } else {
            return selectOrderOption?.validityTypes;
        }
    }, [selectOrderOption?.validityTypes]);


    // const handleKeyPressOnDiv = (e, each) => {
    //     if (e?.code === 'Space' || e?.key === ' ' || e?.key === 'Enter') {
    //         e?.target?.click();
    //     }

    //     // if (e?.target?.id === 'amoValidityShowHide') {

    //     //     if (e?.key === 'Enter' || e?.code === 'Space') {

    //     //         setProfDesc(!profDesc);
    //     //     }
    //     // } else if (e?.target?.id === 'updateMarginInfo') {
    //     //     if (e?.key === 'Enter' || e?.code === 'Space') {

    //     //         marginInfoHandler();
    //     //     }

    //     // } else if (e?.target?.id === 'viewBrokerageCharges') {
    //     //     if (e?.key === 'Enter' || e?.code === 'Space') {

    //     //         BrokerageChargesModal();
    //     //     }
    //     // } else if (e?.target?.id === 'exchangeChip') {
    //     //     if (e?.key === 'Enter' || e?.code === 'Space') {
    //     //         onMarketChange(each);
    //     //     }

    //     // }
    //     // else if (e?.target?.id === 'exchangeChip') {
    //     //     if (e?.key === 'Enter' || e?.code === 'Space') {
    //     //         onMarketChange(each);
    //     //     }
    //     // }
    //     // else if (e?.target?.id === 'searchIconDive') {
    //     //     if (e?.key === 'Enter' || e?.code === 'Space') {
    //     //         setInputSearch(true);
    //     //     }
    //     // }
    //     // else if (e?.target?.id === 'StopLossAndBookProfit') {
    //     //     if (e?.key === 'Enter' || e?.code === 'Space') {
    //     //         onClickCoverBracketOrder();
    //     //     }
    //     // }

    // };

    // Azeem K : 24-09-2024:showing no product type msg after two seconds --Start
    const [bIsNoProdTypeMsgShow, setBIsNoProdTypeMsgShow] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            if (arrAllExchangeWiseProductTypes?.length <= 0) {
                setBIsNoProdTypeMsgShow(true);
            } else {
                setBIsNoProdTypeMsgShow(false);
            }
        }, 2000);

        if (arrAllExchangeWiseProductTypes?.length > 0) {
            setBIsNoProdTypeMsgShow(false);

        }
    }, [arrAllExchangeWiseProductTypes]);
    // Azeem K : 24-09-2024:showing no product type msg after two seconds --End

    // Azeem K :25-10-2024 : BREEZE-293 :Breeze - Watchlist Side tray -Single Scrip Order entry : added DPR (Daily Price Range) validation on order input change: --Start 
    useEffect(() => {
        let { scripPrice, slTrigger, intradayTrigger, intradayLimit, intradayProfit } = orderInputs;

        if (selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.RL_MKT) {

            setBIsDPRError(curr => ({ ...curr, scripPrice: _validateRange(scripPrice, MPHighPr, MPLowPr) }));
        } else {
            setBIsDPRError(curr => ({ ...curr, scripPrice: false }));

        }
        if (selectOrderOption?.orderType === ORDER_ENTRY_TYPES.SL || selectOrderOption?.orderType === ORDER_ENTRY_TYPES.SL_MKT) {
            setBIsDPRError(curr => ({ ...curr, slTrigger: _validateRange(slTrigger, MPHighPr, MPLowPr) }));
        } else {
            setBIsDPRError(curr => ({ ...curr, slTrigger: false }));

        }
        if ((bIsCoverOrderAllowed || bIsBracketOrderAllowed) && toggleBracketOrder?.isShow) {

            const { MPTriggerPriceLowRange, MPTriggerPriceHighRange, MPLimitPriceLowRange, MPLimitPriceHighRange, profitPriceLowRange, profitPriceHighRange } = bracketCoverOrderPriceRange;
            setBIsDPRError(curr => ({ ...curr, intradayTrigger: _validateRange(intradayTrigger, MPTriggerPriceHighRange, MPTriggerPriceLowRange) }));
            setBIsDPRError(curr => ({ ...curr, intradayLimit: _validateRange(intradayLimit, MPLimitPriceHighRange, MPLimitPriceLowRange) }));
            setBIsDPRError(curr => ({ ...curr, intradayProfit: _validateRange(intradayProfit, profitPriceHighRange, profitPriceLowRange) }));
        }


    }, [orderInputs, MPLowPr, selectOrderOption?.orderType, MPHighPr, bIsCoverOrderAllowed, bIsBracketOrderAllowed, toggleBracketOrder?.isShow, bracketCoverOrderPriceRange]);
    // Azeem K :25-10-2024 : BREEZE-293 :Breeze - Watchlist Side tray -Single Scrip Order entry : added DPR (Daily Price Range) validation on order input change: --End

    // Hari K:19-11-2024:seting capPrice on clicking of marketdepth values-start
    const onValueClick = (value) => {
        const nValue = parseFloat(value);
        setOrderInputs(curr => ({ ...curr, scripPrice: nValue, capPrice: nValue.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) })); //BT-142330 :Hotfix Bug fixing : ManasaB : 27-08-2024 : Order SIP Market Depth issue 
    };
    // Hari K:19-11-2024:seting capPrice on clicking of marketdepth values-end

    return (
        <>
            {layoutType === LAYOUT_TYPE.HORIZONTAL ?
                <form onSubmit={handlePlaceOrderButton}>
                    <Container fluid className='p-0'>
                        {/* Vaibhav Singh: 05-02-24: BT-107431: Logic in order user clicks on place an order today : Start */}

                        <Row className='g-0 pt-2'>
                            <Col md={5} className='d-flex justify-content-start align-items-center'>
                                {(!scripOrderInfo?.length) ?
                                    <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromInlineSearch} setBToggleSearchBar={setInputSearch} />
                                    : <>
                                        {inputSearch ?
                                            <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromInlineSearch} setBToggleSearchBar={setInputSearch} />
                                            :
                                            <>
                                                <div className='d-flex flex-column w-100'>
                                                    <div className='d-flex justify-content-start align-items-center'>
                                                        <div className='font-medium font-size4 color-text text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                                        <div className='chips-wrap'>
                                                            <div className='exchange-chip me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                                                        </div>
                                                        {scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE] &&
                                                            <div className='font-regular font-size4 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]}</div>
                                                        }
                                                        {scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] &&
                                                            <div className='font-regular font-size4 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES]}</div>
                                                        }
                                                        {scripOrderInfo?.[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
                                                            <div className='font-regular font-size4 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.STRIKEPRICE]}</div>
                                                        }
                                                        {scripOrderInfo?.[WATCHLIST_GRID_INDEX.OPTIONTYPE] &&
                                                            <div className='font-regular font-size4 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.OPTIONTYPE]}</div>
                                                        }
                                                        <BzButton className='icon-btn p-0 me-2' type='button' onClick={handleScripOverview}><span className='icon-16 icon-eye icon-dark m-t-5'></span></BzButton>
                                                        <BzButton className='icon-btn p-0' type='button' id='searchIcon' onClick={() => setInputSearch(true)} ><span className='icon-16 icon-search icon-dark m-t-5'></span></BzButton>
                                                    </div>
                                                    <div className='d-flex justify-content-start align-items-center'>
                                                        <div className='font-medium font-size3 color-text me-1'>{arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] || (0)?.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])}</div>
                                                        <div className={`font-regular font-size2 color-text ${Number(arrActiveScripInformation[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) > 0 ? 'color-positive' : Number(arrActiveScripInformation[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) < 0 ? 'color-negative' : ''} me-1`}>{arrActiveScripInformation[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] || (0)?.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])}</div>
                                                        <div className={`font-regular font-size2 color-text ${Number(arrActiveScripInformation[WATCHLIST_GRID_INDEX.LTP_PERCENT]) > 0 ? 'color-positive' : Number(arrActiveScripInformation[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) < 0 ? 'color-negative' : ''}`}>({arrActiveScripInformation[WATCHLIST_GRID_INDEX.LTP_PERCENT] || '0.00'}%)</div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </>
                                }
                            </Col>
                            <Col md={7} className='d-flex justify-content-end'>
                                <Container fluid className='p-0'>
                                    <Row className='g-0'>
                                        <Col className='d-flex justify-content-end align-items-center'>
                                            <div className='exch-radiochip-wrap'>
                                                {
                                                    arrDistinctScripExchanges?.length > 0 && scripOrderInfo?.length > 0 && arrDistinctScripExchanges?.map((each, i) => {
                                                        return (
                                                            <BzChip key={i} onClick={(e) => onMarketChange(each)} className={`ms-2 radio-chip ${isModifyOrder ? 'disabled' : ''} ${scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == each[WATCHLIST_GRID_INDEX.SEGMENT_ID] && !isModifyOrder ? 'active' : ''}`} id='exchangeChip' tabIndex='0' onKeyPress={handleKeyDownOnDiv}>  {/* Azeem khan: 20-12-2023 BT-120115 2nd Cycle */}
                                                                <div className={`exch-namechip ${scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == each[WATCHLIST_GRID_INDEX.SEGMENT_ID] ? 'active' : ''}`}>{each[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                                                                <div className='font-regular font-size1 color-text text-end'>{activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ? each[WATCHLIST_GRID_INDEX.ASK_PRICE] : each[WATCHLIST_GRID_INDEX.BID_PRICE]}</div>
                                                                <div className='font-regular font-size1 color-subtext text-end'>QTY: {activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ? each[WATCHLIST_GRID_INDEX.ASK_QTY] : each[WATCHLIST_GRID_INDEX.BID_QUANTITY]}</div>
                                                            </BzChip>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                        </Row>

                        <Row className='g-0 pt-4'>
                            <Col md='auto' className='pe-3'>
                                <div className='font-regular font-size2 color-subtext mb-1'>Product Type</div>
                                <ProductTypeDropdown
                                    selectOrderOption={selectOrderOption} isModifyOrder={isModifyOrder}
                                    arrAllExchangeWiseProductTypes={arrAllExchangeWiseProductTypes}
                                    handleOnSelectOrderOptionChange={handleOnSelectOrderOptionChange}
                                    objActiveExchangeUserPreference={objActiveExchangeUserPreference}
                                    userPreference={userPreference} scripOrderInfo={scripOrderInfo}
                                    bIsHoldingsSell={bIsHoldingsSell}
                                />
                                {
                                    bIsNoProdTypeMsgShow && arrAllExchangeWiseProductTypes?.length <= 0 ?
                                        <div className='d-flex align-items-start mt-1'>
                                            <div className='icon-20 icon-info icon-dark flex-shrink-0'></div>
                                            <div className={`error-msg ms-1`}>No product type available</div>
                                        </div>
                                        :
                                        null
                                }
                            </Col>
                            <Col className='pe-3'>
                                <div className='font-regular font-size2 color-subtext mb-1'>Order Type</div>
                                <div className='Bzmodalselect-dropdown'>
                                    <BzDropdown>
                                        <Dropdown.Toggle tabIndex={isModifyOrder && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT ? -1 : 0} className={`btn-default ${isModifyOrder && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT ? 'disabled' : ''}`} data-testid='toggleOrderTypeDropdown'>{selectOrderOption?.orderType}</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {arrOrderTypeOptions?.length > 0 && arrOrderTypeOptions?.map((eachOption, i) => (
                                                <Dropdown.Item key={i} onClick={(e) => { handleOnSelectOrderOptionChange({ target: { name: 'orderType', value: eachOption } }); }}>{eachOption}</Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </BzDropdown>
                                </div>
                            </Col>
                            <Col className='pe-3'>
                                <div className='d-flex align-items-center mb-1'>
                                    <div className='font-regular font-size2 color-subtext'>{selectOrderOption?.orderBy === "Amount" ? <><span>{selectOrderOption?.orderBy + " in "}</span><span>&#8377;</span></> : selectOrderOption?.orderBy}</div>
                                    <OrderByDropdown handleOnSelectOrderOptionChange={handleOnSelectOrderOptionChange} orderQuantityCaption={orderQuantityCaption} handleOrderInputs={handleOrderInputs} scripOrderInfo={scripOrderInfo} />
                                </div>
                                <div className='input-group postion-relative'>
                                    <div className='icon-12 icon-order-decrease input-number-left-wrap' name={strSelectedInputName} id={strSelectedInputName + 'decrease'} onClick={() => handleOrderStepsOnChange(strSelectedInputName, 'decrease')}></div>
                                    <BzInputText size='sm' type='number' min={0} name={strSelectedInputName} autoFocus value={orderInputs[strSelectedInputName]} className='text-center p-0 font-regular' onKeyDown={restrictInput} onChange={handleOrderInputs} id='qtyInput' />
                                    <div className='icon-12 icon-order-increase input-number-right-wrap' name={strSelectedInputName} id={strSelectedInputName + 'increase'} onClick={() => handleOrderStepsOnChange(strSelectedInputName, 'increase')}></div>
                                </div>
                                {
                                    selectOrderOption?.orderBy == 'Amount' ?
                                        <div className='d-flex align-items-center mt-2'>
                                            <div className={`font-medium font-size1 color-subtext`}>(Approx. {!scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] ? (parseInt(orderInputs?.scripLot) > 1 ? 'Lots' : 'Lot') : 'Qty'}) = {orderInputs?.scripLot} </div>
                                        </div>
                                        :
                                        (!scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] || bIsEqScripHaveLots) ? (
                                            <div className='d-flex align-items-center mt-2'>
                                                <div className='font-medium font-size1 color-subtext'>(1 Lot = {scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT]} {scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT]})</div>
                                            </div>
                                        ) : null
                                }
                            </Col>
                            <Col md={3}>
                                {!selectOrderOption.isOCOChecked ?
                                    <>                                <div className='d-flex justify-content-between mb-1'>
                                        <div className='font-regular font-size2 color-subtext'>
                                            {
                                                selectOrderOption?.orderType == ORDER_ENTRY_TYPES.RL ? ' Limit ' : (
                                                    selectOrderOption?.orderType == ORDER_ENTRY_TYPES.SL_MKT ? ' SL Market ' : (
                                                        selectOrderOption?.orderType == ORDER_ENTRY_TYPES.SL ? ' SL Limit ' : ' Price '
                                                    )
                                                )
                                            }
                                            <span className='font-size1'>(Tick: {scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0})</span>
                                        </div>
                                        <div className='icon-20 icon-marketdepth flex-shrink-0' onClick={handleMarketDepthClick}></div>
                                    </div>
                                        <div className={`input-group align-items-center ${(bIsScripPriceDisabled ? 'disabled' : '')}`}>
                                            <div className='icon-12 icon-order-decrease input-number-left-wrap' name='scripPrice' id='scripPricedecrease' onClick={() => {
                                                if (!bIsScripPriceDisabled) {
                                                    handleOrderStepsOnChange('scripPrice', 'decrease');
                                                } else { }
                                            }}>
                                            </div>
                                            <BzInputText placeholder={orderInputs?.scripPrice == 0 ? '0.00' : ''} disabled={bIsScripPriceDisabled} size='sm' type='text' step={scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0} name='scripPrice' value={orderInputs?.scripPrice} className='text-center p-0 font-regular' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                            <div className='icon-12 icon-order-increase input-number-right-wrap' name='scripPrice' id='scripPriceincrease' onClick={() => {
                                                if (!bIsScripPriceDisabled) {
                                                    handleOrderStepsOnChange('scripPrice', 'increase');
                                                } else { }
                                            }}></div>
                                        </div>
                                        <div className='d-flex align-items-start mt-2'>
                                            <BzToolTip placement='right' TooltipMsg='This Price Range, represents the maximum allowable fluctuation in price during a trading session for a specific scrip. It defines a scrips maximum permitted price movement within a single trading day. User can place their bid within this price range only'>
                                                <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                            </BzToolTip>
                                            <div className={`font-medium font-size1 color-subtext ms-1`}>Range: <span className={`${bIsDPRError?.scripPrice ? 'color-negative' : 'color-text'}`}> {arrActiveScripInformation[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE]}</span></div>
                                        </div>
                                    </>
                                    : null}
                            </Col>
                            {/* When product type is intraday and order type is StopLoss Market this Row should be visible Starts*/}
                            {
                                selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES.SL) &&
                                <Col md={3} className='ps-3'>
                                    <div className='d-flex justify-content-between mb-1'>
                                        <div className='font-regular font-size2 color-subtext'>SL Trigger</div>
                                        <div className='icon-20 icon-marketdepth flex-shrink-0' onClick={handleMarketDepthClick}></div>
                                    </div>
                                    <div className='input-group position-relative'>
                                        <div className='icon-12 icon-order-decrease input-number-left-wrap' name="slTrigger" id='slTriggerdecrease' onClick={() => handleOrderStepsOnChange('slTrigger', 'decrease')}></div>
                                        <BzInputText size='sm' type="text" name="slTrigger" value={orderInputs.slTrigger} className='text-center p-0 form-control font-regular' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                        <div className='icon-12 icon-order-increase input-number-right-wrap' name="slTrigger" id='slTriggerincrease' onClick={() => handleOrderStepsOnChange('slTrigger', 'increase')}></div>
                                    </div>
                                    <div className='d-flex align-items-start mt-2'>
                                        <BzToolTip placement='left' TooltipMsg='This Price Range, represents the maximum allowable fluctuation in price during a trading session for a specific scrip. It defines a scrips maximum permitted price movement within a single trading day. User can place their bid within this price range only'>
                                            <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                        </BzToolTip>
                                        <div className={`font-medium font-size1 color-subtext ms-1`}>Range: <span className={`${bIsDPRError?.slTrigger ? 'color-negative' : 'color-text'}`}> {arrActiveScripInformation[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE]}</span></div>
                                    </div>
                                </Col>
                            }
                            {/* When product type is intraday and order type is StopLoss Market this Row should be visible Ends*/}
                        </Row>
                        {
                            //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - Start
                            //Azeem K :20-03-2025 : bracket and cover order hide as of now as per discussion with Poornima P will be taken in seprate user stoy --Start
                            //-----Dont remove this code
                            //  Azeem K : 08-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start 
                            (bIsCoverOrderAllowed || bIsBracketOrderAllowed) &&
                            (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.INTRADAY || selectOrderOption?.productType === ORDER_PRODUCT_TYPES.MARGIN) &&
                            (selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.SL_MKT && selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.SL) &&
                            selectOrderOption?.validityTypes !== ORDER_VALIDITY.IOC &&
                            //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - End
                            <>
                                <Row className='g-0 py-2 align-items-center'>
                                    <Col md="auto">
                                        <div className='d-flex align-items-center focus' id='StopLossAndBookProfit' tabIndex={0} onKeyPress={handleKeyDownOnDiv} onClick={onClickCoverBracketOrder}>
                                            <div className='d-flex align-items-start cursor-pointer'>{toggleBracketOrder?.isShow ? <div className='icon-16 icon-minus-circle-fill icon-dark me-2'> </div> : <div className='icon-16 icon-add-circle-fill icon-dark me-2'></div>}</div>
                                            <div className='font-medium font-size2 color-text line-height-1 cursor-pointer'>
                                                {bIsBracketOrderAllowed ? 'STOP LOSS / BOOK PROFIT' : 'STOP LOSS'}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                {
                                    toggleBracketOrder?.isShow &&
                                    <div className='stoploss-card p-3 mb-3'>
                                        <Row className='g-0'>
                                            <Col className='justify-content-start me-3'>
                                                <div className='font-regular font-size2 color-subtext mb-1'>SL Trigger</div>
                                                <div className='input-group position-relative'>
                                                    <div className='icon-12 icon-minus icon-grey input-number-left-wrap' name='intradayTrigger' id='intradayTriggerdecrease' onClick={() => handleOrderStepsOnChange('intradayTrigger', 'decrease')}></div>
                                                    {/* Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start */}
                                                    <BzInputText size='sm' type='number' name='intradayTrigger' value={orderInputs.intradayTrigger} className='text-center p-0 form-control-sm color-text  font-regular' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                    {/* Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End */}
                                                    <div className='icon-12 icon-add icon-grey input-number-right-wrap' name='intradayTrigger' id='intradayTriggerincrease' onClick={() => handleOrderStepsOnChange('intradayTrigger', 'increase')}></div>
                                                </div>
                                            </Col>
                                            <Col className='justify-content-start me-3'>
                                                <div className='font-regular font-size2 color-subtext mb-1'>SL Limit</div>
                                                <div className='input-group position-relative'>
                                                    <div className='icon-12 icon-minus icon-grey input-number-left-wrap' name='intradayLimit' id='intradayLimitdecrease' onClick={() => handleOrderStepsOnChange('intradayLimit', 'decrease')}></div>
                                                    {/* Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start */}
                                                    <BzInputText size='sm' type='number' name='intradayLimit' value={orderInputs?.intradayLimit} className='text-center p-0  form-control-sm font-regular' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                    {/* Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End */}
                                                    <div className='icon-12 icon-add icon-grey input-number-right-wrap' name='intradayLimit' id='intradayLimitincreasee' onClick={() => handleOrderStepsOnChange('intradayLimit', 'increase')}></div>
                                                </div>
                                            </Col>
                                            {
                                                toggleBracketOrder?.strProductType == ORDER_PRODUCT_TYPES.BRACKET &&
                                                <Col className='justify-content-start me-3'>
                                                    <div className='font-regular font-size2 color-subtext mb-1'>Trailing SL</div>
                                                    <div className='input-group position-relative'>
                                                        <div className='icon-12 icon-minus icon-grey input-number-left-wrap' name='intradayTrailing' id='intradayTrailingdecrease' onClick={() => handleOrderStepsOnChange('intradayTrailing', 'decrease')}></div>
                                                        {/* Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start */}
                                                        <BzInputText size='sm' type='text' name='intradayTrailing' value={orderInputs?.intradayTrailing} className='text-center p-0 form-control-sm font-regular color-text' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                        {/* Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End */}
                                                        <div className='icon-12 icon-add icon-grey input-number-right-wrap' name='intradayTrailing' id='intradayTrailingincrease' onClick={() => handleOrderStepsOnChange('intradayTrailing', 'increase')}></div>
                                                    </div>
                                                </Col>
                                            }
                                            {
                                                toggleBracketOrder?.strProductType == ORDER_PRODUCT_TYPES.BRACKET &&
                                                <Col className='justify-content-start bdr-lft ps-3'>
                                                    <div className='font-regular font-size2 color-subtext mb-1'>Book Profit</div>
                                                    <div className='input-group position-relative'>
                                                        <div className='icon-12 icon-minus icon-grey input-number-left-wrap' name='intradayProfit' id='intradayProfitdecrease' onClick={() => handleOrderStepsOnChange('intradayProfit', 'decrease')}></div>
                                                        {/* Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start */}
                                                        <BzInputText size='sm' type='text' name="intradayProfit" value={orderInputs.intradayProfit} className='text-center p-0 form-control-sm font-regular color-text' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                        {/* Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End */}
                                                        <div className='icon-12 icon-add icon-grey input-number-right-wrap' name='intradayProfit' id='intradayProfitincrease' onClick={() => handleOrderStepsOnChange('intradayProfit', 'increase')}></div>
                                                    </div>
                                                </Col>
                                            }
                                        </Row>
                                    </div>
                                }
                            </>
                            //Azeem K :20-03-2025 : bracket and cover order hide as of now as per discussion with Poornima P will be taken in seprate user stoy --End
                            //  Azeem K : 08-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End 
                        }

                        {/* //BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start */}
                        {selectOrderOption.isOCOChecked && <Row className='g-0 pt-4 d-flex align-items-center'>
                            <Col md={6} className='d-flex'>
                                <div className='align-items-start font-medium font-size1 color-text'>STOP LOSS</div>
                            </Col>
                            <Col md={6}>
                                <div className='align-items-start font-medium font-size1 color-text'>TARGET</div>
                            </Col>
                        </Row>}

                        {selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT &&
                            // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start
                            <Row className='g-0 pt-2'>
                                {selectOrderOption.isOCOChecked ?
                                    <Col md={3} >
                                        <div className='me-2'>

                                            <div className='d-flex justify-content-between mb-1'>
                                                <div className='font-regular font-size1 color-subtext'>Price
                                                    <span className='font-size1'>(Tick: {scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0})</span>
                                                </div>
                                                <div className='icon-20 icon-marketdepth flex-shrink-0' onClick={handleMarketDepthClick}></div>
                                            </div>
                                            <div className={`input-group align-items-center ${(bIsScripPriceDisabled ? 'disabled' : '')}`}>
                                                <div className='icon-12 icon-order-decrease input-number-left-wrap' name='scripPrice' id='scripPricedecrease' onClick={() => {
                                                    if (!bIsScripPriceDisabled) {
                                                        handleOrderStepsOnChange('scripPrice', 'decrease');
                                                    } else { }
                                                }}>
                                                </div>
                                                <BzInputText placeholder={orderInputs?.scripPrice == 0 ? '0.00' : ''} disabled={bIsScripPriceDisabled} size='sm' type='text' step={scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0} name='scripPrice' value={orderInputs?.scripPrice} className='text-center p-0 font-regular' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                <div className='icon-12 icon-order-increase input-number-right-wrap' name='scripPrice' id='scripPriceincrease' onClick={() => {
                                                    if (!bIsScripPriceDisabled) {
                                                        handleOrderStepsOnChange('scripPrice', 'increase');
                                                    } else { }
                                                }}></div>
                                            </div>
                                            <div className='d-flex align-items-center mt-2'>
                                                <BzToolTip placement='right' TooltipMsg='This Price Range, represents the maximum allowable fluctuation in price during a trading session for a specific scrip. It defines a scrips maximum permitted price movement within a single trading day. User can place their bid within this price range only'>
                                                    <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                </BzToolTip>
                                                <div className={`font-medium font-size1 color-subtext line-height-1 ms-1`}>Range: <span className={`${bIsDPRError?.scripPrice ? 'color-negative' : 'color-text'}`}> {arrActiveScripInformation[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE]}</span></div>
                                            </div>
                                        </div>
                                    </Col> : null}

                                <Col md={3} >
                                    <div className='me-2'>
                                        <div className='d-flex justify-content-between mb-1'>
                                            <div className='font-regular font-size1 color-subtext'>Trigger Price
                                                <span className='font-size1'>(Tick: {scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0})</span>
                                            </div>
                                            <div className='icon-20 icon-marketdepth flex-shrink-0' onClick={handleMarketDepthClick}></div>
                                        </div>
                                        <div className='input-group position-relative'>
                                            <div className='icon-12 icon-order-decrease input-number-left-wrap' name="slTrigger" id='slTriggerdecrease' onClick={() => handleOrderStepsOnChange('slTrigger', 'decrease')}></div>
                                            <BzInputText size='sm' type="text" name="slTrigger" value={orderInputs.slTrigger} className='text-center p-0 form-control font-regular' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                            <div className='icon-12 icon-order-increase input-number-right-wrap' name="slTrigger" id='slTriggerincrease' onClick={() => handleOrderStepsOnChange('slTrigger', 'increase')}></div>
                                        </div>
                                    </div>
                                </Col>
                                {selectOrderOption?.isOCOChecked ?
                                    <>
                                        <Col md={3} >
                                            <div className='me-2'>
                                                <div className='d-flex justify-content-between mb-1'>
                                                    <div className='font-regular font-size1 color-subtext'>Price
                                                        <span className='font-size1'>(Tick: {scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0})</span>
                                                    </div>
                                                    <div className='icon-20 icon-marketdepth flex-shrink-0' onClick={handleMarketDepthClick}></div>
                                                </div>
                                                <div className={`input-group align-items-center ${(bIsScripPriceDisabled ? 'disabled' : '')}`}>
                                                    <div className='icon-12 icon-order-decrease input-number-left-wrap' name='targetSelPrice' id='targetSelPricedecrease' onClick={() => {
                                                        handleOrderStepsOnChange('targetSelPrice', 'decrease');
                                                    }}>
                                                    </div>
                                                    <BzInputText placeholder={orderInputs?.targetSelPrice == 0 ? '0.00' : ''} disabled={bIsScripPriceDisabled} size='sm' type='text' step={scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0} name='targetSelPrice' value={orderInputs?.targetSelPrice} className='text-center p-0 font-regular' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                    <div className='icon-12 icon-order-increase input-number-right-wrap' name='targetSelPrice' id='targetSelPriceincrease' onClick={() => {
                                                        if (!bIsScripPriceDisabled) {
                                                            handleOrderStepsOnChange('targetSelPrice', 'increase');
                                                        } else { }
                                                    }}></div>
                                                </div>
                                            </div>
                                        </Col>

                                        <Col md={3} >
                                            <div className='d-flex justify-content-between mb-1'>
                                                <div className='font-regular font-size1 color-subtext'>Trigger Price
                                                    <span className='font-size1'>(Tick: {scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0})</span>
                                                </div>
                                                <div className='icon-20 icon-marketdepth flex-shrink-0' onClick={handleMarketDepthClick}></div>
                                            </div>
                                            <div className='input-group position-relative'>
                                                <div className='icon-12 icon-order-decrease input-number-left-wrap' name="targetSelTriggerPrice" id='targetSelTriggerPricedecrease' onClick={() => handleOrderStepsOnChange('targetSelTriggerPrice', 'decrease')}></div>
                                                <BzInputText size='sm' type="text" name="targetSelTriggerPrice" value={orderInputs.targetSelTriggerPrice} className='text-center p-0 form-control font-regular' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                <div className='icon-12 icon-order-increase input-number-right-wrap' name="targetSelTriggerPrice" id='targetSelTriggerPriceincrease' onClick={() => handleOrderStepsOnChange('targetSelTriggerPrice', 'increase')}></div>
                                            </div>
                                        </Col>
                                    </> : null}
                            </Row>
                            // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End
                        }
                        {/* //BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025  -End */}

                        {/* Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Stat
                              BREEZE-4394 LLD Creation :conditionally GTT and OCO input jsx will be add here for hoizontal order enty
                         Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End*/}

                        <Row className='g-0 my-4'>
                            <Col>
                                <div className='d-flex align-items-center'>
                                    <div className='d-flex align-items-center cursor-pointer focus' id='amoValidityShowHide' onKeyPress={handleKeyDownOnDiv} tabIndex='0' onClick={() => setProfDesc(!profDesc)}>
                                        {profDesc ? <div className='icon-14 icon-minus icon-dark me-2'></div> : <div className='icon-14 icon-add icon-dark me-2'></div>}
                                        <div className='font-medium font-size1 color-text text-uppercase'>{profDesc ? <span>Hide</span> : <span>SHOW</span>} VALIDITY, AMO {(selectOrderOption?.validityTypes != ORDER_VALIDITY.IOC && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.NSE_DERIVATIVES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.BSE_DERIVATIVES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.MSX_DERIVATIVES) ? '& DISC.' + (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'QTY' : 'LOT') : null}</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {/* The below row should open when Clicked on 'SHOW PROT% & DISC. QTY' and the Text 'show' be replaced by 'Hide'*/}
                        {profDesc &&
                            <Row className='g-0 mb-4 pb-3'>
                                <Col md={2} className='d-flex flex-column pe-3'>
                                    <div className='d-flex align-item-start mb-1'>
                                        <div className=' font-regular font-size2 color-subtext'>Validity</div>
                                        <BzToolTip placement='right' TooltipMsg={strValidityMessage}>
                                            <div className='icon-16 icon-info icon-dark flex-shrink-0 ms-1'></div>
                                        </BzToolTip>
                                    </div>
                                    <div className='Bzmodalselect-dropdown'>
                                        <BzDropdown>
                                            <Dropdown.Toggle tabIndex={isModifyOrder && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT ? -1 : 0} className={`btn-default ${isModifyOrder && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT ? 'disabled' : ''}`}>{selectOrderOption?.validityTypes}</Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {validityTypes?.length > 0 && validityTypes?.map((eachOption, i) => (
                                                    <Dropdown.Item key={i} onClick={(e) => { handleOnSelectOrderOptionChange({ target: { name: 'validityTypes', value: eachOption } }); }}>{eachOption}</Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </BzDropdown>
                                    </div>
                                    {/* //BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start */}
                                    {GTTValidDate && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT &&
                                        <div className='d-flex align-items-start mt-1'>

                                            <div className={`font-medium font-size1 color-subtext`}><span>Valid Till</span> <span className='color-text'>{GTTValidDate}</span></div>
                                        </div>
                                    }
                                </Col>
                                {/* //BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End */}
                                {
                                    isGTDDropdown &&
                                    <Col md={3} className='d-flex flex-column align-items-start pe-3'>
                                        <div className='font-regular font-size2 color-subtext mb-1'>GTD Date</div>
                                        <div className='datepicker-wrap p-0 mb-1'>
                                            <BzDatePicker className='form-datepicker-secondary form-control form-control-sm font-medium py-1 px-2' defaultValue={orderInputs?.gtdDate} disabledDate={disabledDate} mode={'date'} dateFormat={"MMM DD, YYYY"} picker={"date"} onDateChange={onDateChange} />
                                        </div>
                                        <div className='font-medium font-size1 color-subtext'>GTD Days: <span className='color-text'>{nGTDNoOfDays}</span></div>
                                    </Col>
                                }

                                {/* <Row className='g-0 align-items-center'> */}
                                {
                                    // selectOrderOption?.orderType?.includes('MKT') &&
                                    // <Col className='me-3'>
                                    //     <div className='font-regular font-size2 color-subtext mb-1'>Prot %</div>
                                    //     <div className='input-group align-items-center form-control p-0 px-2'>
                                    //         {/* Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start */}
                                    //         <BzInputText size='sm' type='number' name='protPercent' value={orderInputs.protPercent} onChange={handleOrderInputs} className='text-left p-0 font-regular bdr-none' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} placeholder='0.00' />
                                    //         {/* Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End */}
                                    //         <div className='font-regular font-size2 color-subtext'>%</div>
                                    //     </div>
                                    // </Col>

                                }

                                {
                                    (selectOrderOption?.validityTypes != ORDER_VALIDITY.IOC && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.NSE_DERIVATIVES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.BSE_DERIVATIVES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.MSX_DERIVATIVES) &&
                                    <Col md='auto' className='d-flex flex-column align-item-start pe-3'>
                                        <div className='d-flex align-item-center mb-1'>
                                            <div className='font-regular font-size2 color-subtext'>Disclosed {scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'Qty' : 'Lot'}</div>
                                            <BzToolTip TooltipMsg='Disclosed quantity allows you to disclose only a part of the actual quantity you want to buy/sell.' placement='right'>
                                                <div className='icon-16 icon-info icon-dark flex-shrink-0 ms-1'></div>
                                            </BzToolTip>
                                        </div>
                                        <BzInputText name='discQty' size='sm' type='number' value={orderInputs.discQty} onChange={handleOrderInputs} className='font-regular' onKeyDown={restrictInput} placeholder='0' />
                                        <div className='d-flex justify-content-start align-items-center mt-1'>
                                            <div className='font-medium font-size1 color-subtext'>Min Disc {scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'Qty: ' : 'Lot: '}
                                                <span className='color-text'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? + nMinDiscQty : + nMinDiscLot}</span>
                                            </div>
                                        </div>
                                    </Col>
                                }


                                {/* Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Stat*/}
                                {bIsOCOAllowed && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT ? <Col md='auto' className='d-flex align-items-start p-t-30'>
                                    <input type='checkbox' name='isOCOChecked' disabled={isModifyOrder} defaultChecked={selectOrderOption?.isOCOChecked} checked={selectOrderOption?.isOCOChecked} className='form-check-input me-2' value={selectOrderOption?.isOCOChecked} onChange={e => {
                                        handleOnSelectOrderOptionChange({ target: { name: e.target.name, value: !selectOrderOption?.isOCOChecked } });
                                    }} />
                                    <div className='font-medium font-size1 color-text text-uppercase me-1'>OCO</div>
                                    <BzToolTip placement='top' TooltipMsg='The OCO (One Cancels Other) feature allows you to place two orders: Stop Loss (SL) and Profit booking. If either one is triggered, the system automatically cancels the other, ensuring profit protection and minimizing potential losses'>
                                        <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                    </BzToolTip>
                                </Col> : selectOrderOption?.validityTypes !== ORDER_VALIDITY.GTT ?
                                    <Col md='auto' className='d-flex align-items-start p-t-30'>
                                        <input type='checkbox' name='isAmo' disabled={isModifyOrder} defaultChecked={selectOrderOption?.isAmo} checked={selectOrderOption?.isAmo} className='form-check-input me-2' value={selectOrderOption?.isAmo} onChange={e => {
                                            handleOnSelectOrderOptionChange({ target: { name: e.target.name, value: !selectOrderOption?.isAmo } });
                                        }} />
                                        <div className='font-medium font-size1 color-text text-uppercase me-1'>AMO</div>
                                        <BzToolTip placement='top' TooltipMsg='After Market Order(AMO) is a trade that allows you to buy/sell outside of regular trading hours'>
                                            <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                        </BzToolTip>
                                    </Col> : null}
                                {/*      Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End*/}
                            </Row>
                        }

                        <Row className='bdr-top pt-3'>
                            <Col md={7} className='d-flex justify-content-start align-items-center'>
                                <div className='d-flex flex-column justify-content-start pe-4'>
                                    <div className='font-regular font-size1 color-text'>Approx. Margin</div>
                                    {
                                        isLoadingMarginInfo ?
                                            <BzDotsLoader />
                                            :
                                            <div className='font-medium font-size1 color-text'>{!isNaN(parseFloat(arrMarginInfo?.ApproxMargin)) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.ApproxMargin), true) : arrMarginInfo?.ApproxMargin}</div>
                                    }
                                </div>
                                <div className='d-flex flex-column justify-content-start pe-4'>
                                    <div className='font-regular font-size1 color-text'>Available Margin: </div>
                                    {

                                        isLoadingMarginInfo ?
                                            <BzDotsLoader />
                                            :
                                            <div className='font-medium font-size1 color-text'>{!isNaN(parseFloat(arrMarginInfo?.AvailableMargin)) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.AvailableMargin), true) : arrMarginInfo?.AvailableMargin}</div>
                                    }
                                </div>
                                {
                                    !isLoadingMarginInfo &&
                                    <div className='d-flex align-items-center pe-4 cursor-pointer focus' tabIndex='0' onKeyPress={handleKeyDownOnDiv} id='updateMarginInfo' onClick={() => marginInfoHandler()}>
                                        <div className='icon-12 icon-refresh background-textual-link-withicon'></div>
                                        <div className='font-medium font-size1 color-textual-link-withicon ms-2'>Update</div>
                                    </div>
                                }
                            </Col>
                            <Col md={5} className='d-flex justify-content-end align-items-center'>
                                <div className='font-medium font-size1 color-text me-4 focus p-1 cursor-pointer' disabled={isBrokerageDisabled} tabIndex='0' onKeyPress={handleKeyDownOnDiv} id='viewBrokerageCharges' onClick={BrokerageChargesModal}>Brokerage &amp; Charges</div>
                                <BzButton type='submit' disabled={bIsPlaceOrderBtnDisabled} className={`btn btn-md ${activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ? 'btn-positive' : 'btn-negative'} text-capitalize`}>{isModifyOrder ? 'Modify Order' : 'Place Order'}</BzButton>
                            </Col>
                        </Row>
                        {
                            isShowMarketDepth &&
                            <div ref={marketDepthRef}>
                                <Row className='bdr-top px-2 py-3 mt-3'>
                                    <Container fluid className='p-0'>
                                        <Row className='g-0' >
                                            <Col className='d-flex justify-content-start align-items-center'>
                                                <div className='submenu-wrapper d-flex align-items-center'>
                                                    <div tabIndex={0} onKeyDown={handleKeyDownOnDiv} onClick={() => setMarketDepthActiveTab('market_depth')} className={`submenuItem ${marketDepthActiveTab == 'market_depth' ? 'active' : ''}`}>Market Depth</div>
                                                    <div tabIndex={0} onKeyDown={handleKeyDownOnDiv} onClick={() => setMarketDepthActiveTab('support_resistance')} className={`submenuItem ${marketDepthActiveTab == 'support_resistance' ? 'active' : ''}`}>Support/Resistance</div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <div>
                                            {marketDepthActiveTab === "market_depth" ? <AllExchangesMarketDepth heading={false} /> : marketDepthActiveTab === "support_resistance" ? <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} layoutType={LAYOUT_TYPE.HORIZONTAL} /> : null}
                                        </div>
                                    </Container>
                                </Row>
                            </div>
                        }

                        {/* Ajitesh : 07/12/2023: BT-109135: Breeze eDIS implementation - Start*/}
                        <BzModal size="lg" show={modals["EDIS_PERMISSION_MODAL_SINGLE_ORDER"]} onHide={handleClose}>
                            <BzModalHeader className='modaltabs-header pb-0'>
                                <Container fluid className='p-0'>
                                    <Row className='g-0'>
                                        <Col className='d-flex justify-content-start align-items-end mb-2'>
                                            <BzModalTitle className='font-medium font-size6 color-text'>Edis Permission</BzModalTitle>
                                        </Col>
                                        <Col md={1} className='d-flex justify-content-end align-items-center mb-2'>
                                            <div onClick={handleClose} className='icon-16 icon-close icon-dark ms-3' />
                                        </Col>
                                    </Row>
                                </Container>
                            </BzModalHeader>
                            <BzModalBody>
                                <Edis singleScripOrderData={singleScripDataForEdis} mode="singleOrder" isAmo={selectOrderOption?.isAmo} handleResponseForAmoSell={(resp) => handleResponseForAmoSell(resp)} showOrderConfirmModal={showOrderConfirmModal} orderData={orderData} />
                            </BzModalBody>
                        </BzModal>
                        {/* Ajitesh : 07/12/2023: BT-109135: Breeze eDIS implementation - End*/}

                    </Container>
                </form>
                : layoutType === LAYOUT_TYPE.VERTICAL ?
                    <div className='sticky-orderticket-singlescrip'>
                        <Container fluid className='p-0'>
                            {isHeader ?
                                <>
                                    <Row className='g-0 ps-3 mt-2'>
                                        {
                                            !scripOrderInfo?.length ?
                                                <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromInlineSearch} setBToggleSearchBar={setInputSearch} />

                                                : inputSearch ?
                                                    <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromInlineSearch} setBToggleSearchBar={setInputSearch} />
                                                    :
                                                    <>
                                                        <Row className='g-0'>
                                                            <Col className='d-flex justify-content-start align-items-start'>
                                                                <Container fluid className='p-0'>
                                                                    <Row className='g-0'>
                                                                        <Col className='d-flex justify-content-start align-items-center'>
                                                                            <div className='font-medium font-size4 color-text text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                                                            <div className='chips-wrap'>
                                                                                <div className='exchange-chip me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                                                                            </div>
                                                                            <div className='icon-16 icon-eye icon-dark me-2' onClick={handleScripOverview}></div>
                                                                            <div className='icon-16 icon-search icon-dark' id='searchIcon' onClick={() => setInputSearch(true)}></div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className='g-0 mt-1'>
                                                                        <Col className='d-flex justify-content-start align-items-start'>
                                                                            {scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE] &&
                                                                                <div className='font-regular font-size3 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]}</div>
                                                                            }
                                                                            {scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] &&
                                                                                <div className='font-regular font-size3 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES]}</div>
                                                                            }
                                                                            {scripOrderInfo?.[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
                                                                                <div className='font-regular font-size3 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.STRIKEPRICE]}</div>
                                                                            }
                                                                            {scripOrderInfo?.[WATCHLIST_GRID_INDEX.OPTIONTYPE] &&
                                                                                <div className='font-regular font-size3 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.OPTIONTYPE]}</div>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </Container>
                                                            </Col>
                                                        </Row>
                                                        <Row className='g-0'>
                                                            <Col className='d-flex justify-content-start align-items-start'>
                                                                <div className='font-medium font-size4 color-text'>{arrActiveScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] || (0)?.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])}</div>
                                                                <div className={`font-regular font-size4 color-text ms-1 ${Number(arrActiveScripInformation[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) > 0 ? 'color-positive' : Number(arrActiveScripInformation[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) < 0 ? 'color-negative' : ''}`}>
                                                                    {arrActiveScripInformation[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] || (0)?.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])} ({arrActiveScripInformation[WATCHLIST_GRID_INDEX.LTP_PERCENT] || '0.00'}%)
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </>
                                        }
                                    </Row>
                                    {/*Commented as code is been moved to sidetray PlaceOrder index.js file - by Vaibhav S and Sumit G*/}
                                    {/* <Row className='g-0 mb-3'>
                                <Col className='d-flex align-items-center horizontal-scroll-wrap pb-1'>
                                    <div className='exch-radiochip-wrap ms-auto'>
                                        {
                                            arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((each, i) => {
                                                return (
                                                    <BzChip key={i} onClick={(e) => onMarketChange(each)} className={`ms-2 radio-chip ${isModifyOrder ? 'disabled' : ''} ${scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == each[WATCHLIST_GRID_INDEX.SEGMENT_ID] && !isModifyOrder ? 'active' : ''}`}>
                                                        <div className={`exch-namechip ${scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == each[WATCHLIST_GRID_INDEX.SEGMENT_ID] ? 'active' : ''}`}>{each[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                                                        <div className='font-regular font-size1 color-primary text-end'>{activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ? each[WATCHLIST_GRID_INDEX.ASK_PRICE] : each[WATCHLIST_GRID_INDEX.BID_PRICE]}</div>
                                                        <div className='font-regular font-size1 color-subtext text-end'>QTY: {activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ? each[WATCHLIST_GRID_INDEX.ASK_QTY] : each[WATCHLIST_GRID_INDEX.BID_QUANTITY]}</div>
                                                    </BzChip>
                                                );
                                            })
                                        }
                                    </div>
                                </Col>
                            </Row> */}
                                </>
                                :
                                <>
                                    <div className='px-3'>
                                        <Row className={bIsNoProdTypeMsgShow && arrAllExchangeWiseProductTypes?.length <= 0 ? 'mb-1' : 'mb-3'}>
                                            <Col md={6}>
                                                <div className='font-regular font-size2 color-subtext mb-1'>Product Type</div>
                                                <ProductTypeDropdown selectOrderOption={selectOrderOption} arrAllExchangeWiseProductTypes={arrAllExchangeWiseProductTypes} handleOnSelectOrderOptionChange={handleOnSelectOrderOptionChange} objActiveExchangeUserPreference={objActiveExchangeUserPreference} userPreference={userPreference} scripOrderInfo={scripOrderInfo} />
                                            </Col>
                                            <Col md={6}>
                                                <div className='font-regular font-size2 color-subtext mb-1'>Order Type</div>
                                                <div className='Bzmodalselect-dropdown'>
                                                    <BzDropdown>
                                                        <Dropdown.Toggle className='btn-default'>{selectOrderOption?.orderType}</Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {arrOrderTypeOptions?.length > 0 && arrOrderTypeOptions?.map((eachOption, i) => (
                                                                <Dropdown.Item key={i} onClick={(e) => { handleOnSelectOrderOptionChange({ target: { name: 'orderType', value: eachOption } }); }}>{eachOption}</Dropdown.Item>
                                                            ))}
                                                        </Dropdown.Menu>
                                                    </BzDropdown>
                                                </div>
                                            </Col>
                                        </Row>
                                        {bIsNoProdTypeMsgShow && arrAllExchangeWiseProductTypes?.length <= 0 ?
                                            <Row className='g-0 mb-2'>
                                                <Col md={12}>
                                                    <div className='d-flex align-items-start mt-1'>
                                                        <div className='icon-20 icon-info icon-dark flex-shrink-0'></div>
                                                        <div className={`error-msg ms-1`}>No product type available</div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            : null}
                                        <Row className='mb-3'>
                                            <Col md={6} className='flex-column align-items-start'>
                                                <div className='d-flex align-items-center mb-1'>
                                                    <div className='font-regular font-size2 color-subtext'>{selectOrderOption?.orderBy}</div>
                                                    <OrderByDropdown handleOnSelectOrderOptionChange={handleOnSelectOrderOptionChange} orderQuantityCaption={orderQuantityCaption} handleOrderInputs={handleOrderInputs} scripOrderInfo={scripOrderInfo} />
                                                </div>
                                                <div className='input-group position-relative'>
                                                    <div className='icon-12 icon-order-decrease input-number-left-wrap' name={strSelectedInputName} id={strSelectedInputName + 'decrease'} onClick={() => handleOrderStepsOnChange(strSelectedInputName, 'decrease')}></div>
                                                    <BzInputText size='sm' type='number' min={0} name={strSelectedInputName} autoFocus value={orderInputs[strSelectedInputName]} className='text-center p-0 font-regular' onKeyDown={restrictInput} onChange={handleOrderInputs} />
                                                    <div className='icon-12 icon-order-increase input-number-right-wrap' name={strSelectedInputName} id={strSelectedInputName + 'increase'} onClick={() => handleOrderStepsOnChange(strSelectedInputName, 'increase')}></div>
                                                </div>
                                                {
                                                    selectOrderOption?.orderBy == 'Amount' ?
                                                        <div className='d-flex align-items-center mt-2'>
                                                            <div className='font-medium font-size1 color-subtext ms-1'>(Approx. {!scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] ? (parseInt(orderInputs?.scripLot) > 1 ? 'Lots' : 'Lot') : 'Qty'}) = {orderInputs?.scripLot} </div>
                                                        </div> : (
                                                            !scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] && (
                                                                <div className='d-flex align-items-center mt-2'>
                                                                    <div className='font-medium font-size1 color-subtext ms-1'>(1 Lot = {scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT]} {scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT]})</div>
                                                                </div>
                                                            )
                                                        )
                                                }
                                            </Col>
                                            {selectOrderOption?.validityTypes !== ORDER_VALIDITY.GTT && !selectOrderOption?.isOCOChecked &&
                                                <Col md={6} className='flex-column align-items-start'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='font-regular font-size2 color-subtext'>
                                                            {
                                                                selectOrderOption?.orderType == ORDER_ENTRY_TYPES.RL ? ' Limit ' : (
                                                                    selectOrderOption?.orderType == ORDER_ENTRY_TYPES.SL_MKT ? ' SL Market ' : (
                                                                        selectOrderOption?.orderType == ORDER_ENTRY_TYPES.SL ? ' SL Limit ' : ' Price '
                                                                    )
                                                                )
                                                            }
                                                            <span className='font-size1'>
                                                                (Tick: {scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0})
                                                            </span>
                                                        </div>
                                                        <div onClick={handleMarketDepthClick} className='icon-20 icon-marketdepth flex-shrink-0'></div>
                                                    </div>
                                                    <div className={`input-group position-relative ${(bIsScripPriceDisabled ? 'disabled' : '')}`}>
                                                        <div className='icon-12 icon-order-decrease input-number-left-wrap' name='scripPrice' id='scripPricedecrease' onClick={() => {
                                                            if (!bIsScripPriceDisabled) {
                                                                handleOrderStepsOnChange('scripPrice', 'decrease');
                                                            } else { }
                                                        }}>
                                                        </div>
                                                        <BzInputText placeholder={orderInputs?.scripPrice == 0 ? '0.00' : ''} disabled={bIsScripPriceDisabled} size='sm' type='text' step={scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0} name='scripPrice' value={orderInputs?.scripPrice} className='text-center p-0 font-regular' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                        <div className='icon-12 icon-order-increase input-number-right-wrap' name='scripPrice' id='scripPriceincrease' onClick={() => {
                                                            if (!bIsScripPriceDisabled) {
                                                                handleOrderStepsOnChange('scripPrice', 'increase');
                                                            } else { }
                                                        }}>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex align-items-center mt-2'>
                                                        <BzToolTip placement='left' TooltipMsg='This Price Range, represents the maximum allowable fluctuation in price during a trading session for a specific scrip. It defines a scrips maximum permitted price movement within a single trading day. User can place their bid within this price range only'>
                                                            <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                        </BzToolTip>
                                                        <div className='font-medium font-size1 color-subtext ms-1'>Range: <span className={`${bIsDPRError?.scripPrice ? 'color-negative' : 'color-text'}`}> {arrActiveScripInformation[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE]}</span></div>
                                                    </div>
                                                </Col>}
                                        </Row>
                                        {(selectOrderOption?.orderType.includes(ORDER_ENTRY_TYPES.SL) || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT) &&
                                            <Row className='mb-3'>
                                                {/* // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start */}
                                                {bIsOCOAllowed && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && selectOrderOption?.isOCOChecked &&
                                                    <>
                                                        <div className='d-flex align-items-start justify-content-between mb-2'>
                                                            <div className='font-regular font-size1 color-text'>STOP LOSS</div>
                                                        </div>
                                                        <Col md={6} className='flex-column align-items-start'>

                                                            <div className='d-flex align-items-center justify-content-between mb-1'>
                                                                <div className='font-regular font-size2 color-subtext'>Price
                                                                    <span className='font-size1'>
                                                                        (Tick: {scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0})
                                                                    </span>
                                                                </div>
                                                                <div onClick={handleMarketDepthClick} className='icon-20 icon-marketdepth flex-shrink-0'></div>
                                                            </div>
                                                            <div className={`input-group position-relative ${(bIsScripPriceDisabled ? 'disabled' : '')}`}>
                                                                <div className='icon-12 icon-order-decrease input-number-left-wrap' name='scripPrice' id='scripPricedecrease' onClick={() => {
                                                                    if (!bIsScripPriceDisabled) {
                                                                        handleOrderStepsOnChange('scripPrice', 'decrease');
                                                                    } else { }
                                                                }}>
                                                                </div>
                                                                <BzInputText placeholder={orderInputs?.scripPrice == 0 ? '0.00' : ''} disabled={bIsScripPriceDisabled} size='sm' type='text' step={scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0} name='scripPrice' value={orderInputs?.scripPrice} className='text-center p-0 font-regular' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                                <div className='icon-12 icon-order-increase input-number-right-wrap' name='scripPrice' id='scripPriceincrease' onClick={() => {
                                                                    if (!bIsScripPriceDisabled) {
                                                                        handleOrderStepsOnChange('scripPrice', 'increase');
                                                                    } else { }
                                                                }}>
                                                                </div>
                                                            </div>
                                                            <div className='d-flex align-items-center mt-2'>
                                                                <BzToolTip placement='left' TooltipMsg='This Price Range, represents the maximum allowable fluctuation in price during a trading session for a specific scrip. It defines a scrips maximum permitted price movement within a single trading day. User can place their bid within this price range only'>
                                                                    <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                                </BzToolTip>
                                                                <div className='font-medium font-size1 color-subtext ms-1'>Range: <span className={`${bIsDPRError?.scripPrice ? 'color-negative' : 'color-text'}`}> {arrActiveScripInformation[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE]}</span></div>
                                                            </div>
                                                        </Col>
                                                    </>}
                                                {/* // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End */}
                                                <Col md={6} className='flex-column align-items-start'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='font-regular font-size2 color-subtext'>{selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT ? 'Trigger Price' : 'SL Trigger'}</div>
                                                        </div>
                                                        <div className='icon-20 icon-marketdepth flex-shrink-0' onClick={handleMarketDepthClick}></div>
                                                    </div>
                                                    <div className='input-group position-relative'>
                                                        <div className='icon-12 icon-order-decrease input-number-left-wrap' name="slTrigger" id='slTriggerdecrease' onClick={() => handleOrderStepsOnChange('slTrigger', 'decrease')}></div>
                                                        <BzInputText size='sm' type="number" name="slTrigger" value={orderInputs.slTrigger} className='p-0 font-regular text-center' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                        <div className='icon-12 icon-order-increase input-number-right-wrap' name="slTrigger" id='slTriggerincrease' onClick={() => handleOrderStepsOnChange('slTrigger', 'increase')}></div>
                                                    </div>
                                                    {selectOrderOption?.orderType.includes(ORDER_ENTRY_TYPES.SL) ?
                                                        <div className='d-flex align-items-center mt-2'>
                                                            <BzToolTip placement='right' TooltipMsg='This Price Range, represents the maximum allowable fluctuation in price during a trading session for a specific scrip. It defines a scrips maximum permitted price movement within a single trading day. User can place their bid within this price range only'>
                                                                <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                            </BzToolTip>
                                                            <div className='font-medium font-size1 color-subtext ms-1'>Range: <span className={`${bIsDPRError?.slTrigger ? 'color-negative' : 'color-text'}`}> {arrActiveScripInformation[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE]}</span></div>
                                                        </div> : null}
                                                </Col>
                                            </Row>
                                        }
                                        {/* // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start  */}
                                        {selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && selectOrderOption?.isOCOChecked && bIsOCOAllowed &&
                                            <Row className='mb-3'>
                                                <div className='d-flex align-items-start justify-content-between mb-2'>
                                                    <div className='font-regular font-size1 color-text'>TARGET</div>
                                                </div>
                                                <Col md={6} className='flex-column align-items-start'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='font-regular font-size2 color-subtext'>Price
                                                            <span className='font-size1'>
                                                                (Tick: {scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0})
                                                            </span>
                                                        </div>
                                                        <div onClick={handleMarketDepthClick} className='icon-20 icon-marketdepth flex-shrink-0'></div>
                                                    </div>
                                                    <div className={`input-group position-relative ${(bIsScripPriceDisabled ? 'disabled' : '')}`}>
                                                        <div className='icon-12 icon-order-decrease input-number-left-wrap' name='targetSelPrice' id='targetSelPricedecrease' onClick={() => { handleOrderStepsOnChange('targetSelPrice', 'decrease'); }}>
                                                        </div>
                                                        <BzInputText placeholder={orderInputs?.targetSelPrice == 0 ? '0.00' : ''} size='sm' type='text' step={scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] : 0} name='targetSelPrice' value={orderInputs?.targetSelPrice} className='text-center p-0 font-regular' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                        <div className='icon-12 icon-order-increase input-number-right-wrap' name='targetSelPrice' id='targetSelPriceincrease' onClick={() => { handleOrderStepsOnChange('targetSelPrice', 'increase'); }}>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex align-items-center mt-2'>
                                                        <BzToolTip placement='left' TooltipMsg='This Price Range, represents the maximum allowable fluctuation in price during a trading session for a specific scrip. It defines a scrips maximum permitted price movement within a single trading day. User can place their bid within this price range only'>
                                                            <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                        </BzToolTip>
                                                        <div className='font-medium font-size1 color-subtext ms-1'>Range: <span className={`${bIsDPRError?.scripPrice ? 'color-negative' : 'color-text'}`}> {arrActiveScripInformation[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE]}</span></div>
                                                    </div>
                                                </Col>
                                                <Col md={6} className='flex-column align-items-start'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='font-regular font-size2 color-subtext'>Trigger Price</div>
                                                        </div>
                                                        <div className='icon-20 icon-marketdepth flex-shrink-0' onClick={handleMarketDepthClick}></div>
                                                    </div>
                                                    <div className='input-group position-relative'>
                                                        <div className='icon-12 icon-order-decrease input-number-left-wrap' name="targetSelTriggerPrice" id='targetSelTriggerPricedecrease' onClick={() => handleOrderStepsOnChange('targetSelTriggerPrice', 'decrease')}></div>
                                                        <BzInputText size='sm' type="number" name="targetSelTriggerPrice" value={orderInputs.targetSelTriggerPrice} className='p-0 font-regular text-center' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                        <div className='icon-12 icon-order-increase input-number-right-wrap' name="targetSelTriggerPrice" id='targetSelTriggerPriceincrease' onClick={() => handleOrderStepsOnChange('targetSelTriggerPrice', 'increase')}></div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        }
                                        {/* // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End  */}

                                        {/* Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Stat
                                                    BREEZE-4394 LLD Creation :conditionally GTT and OCO input jsx will be add here for side tray order entry
                                          Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End*/}

                                        {
                                            //Azeem K :20-03-2025 : bracket and cover order hide as of now as per discussion with Poornima P will be taken in seprate user stoy --Start
                                            //-----Dont remove this code
                                            //  Azeem K : 08-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start 
                                            (bIsCoverOrderAllowed || bIsBracketOrderAllowed) &&
                                            (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.INTRADAY || selectOrderOption?.productType === ORDER_PRODUCT_TYPES.MARGIN) &&
                                            (selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.SL_MKT || selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.SL) &&
                                            selectOrderOption?.validityTypes !== ORDER_VALIDITY.IOC &&
                                            <>
                                                <Row className='mb-3'>
                                                    <Col md='auto'>
                                                        <div className='d-flex align-items-center focus'>
                                                            <div className='d-flex align-items-start cursor-pointer' onClick={onClickCoverBracketOrder}>{toggleBracketOrder?.isShow ? <span className='icon-16 icon-minus-circle-fill icon-dark me-2'></span> : <span className='icon-16 icon-add-circle-fill icon-dark me-2'></span>}</div>
                                                            <div className='font-medium font-size2 color-text cursor-pointer' onClick={onClickCoverBracketOrder}>
                                                                {bIsBracketOrderAllowed ? 'STOP LOSS / BOOK PROFIT' : 'STOP LOSS'}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {toggleBracketOrder?.isShow &&
                                                    <div className='stoploss-card p-3 mb-3'>
                                                        <Row className='mb-3'>
                                                            <Col md={6} className='flex-column align-items-start'>
                                                                <div className='d-flex align-items-center mb-1'>
                                                                    <div className='font-regular font-size2 color-subtext mb-1'>SL Trigger</div>
                                                                </div>
                                                                <div className='input-group position-relative'>
                                                                    <div className='icon-12 icon-minus icon-grey input-number-left-wrap' name='intradayTrigger' id='intradayTriggerdecrease' onClick={() => handleOrderStepsOnChange('intradayTrigger', 'decrease')}></div>
                                                                    <BzInputText size='sm' type='number' name='intradayTrigger' value={orderInputs.intradayTrigger} className='p-0 font-regular text-center' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                                    <div className='icon-12 icon-add icon-grey input-number-right-wrap' name='intradayTrigger' id='intradayTriggerincrease' onClick={() => handleOrderStepsOnChange('intradayTrigger', 'increase')}></div>
                                                                </div>
                                                            </Col>
                                                            <Col md={6} className='flex-column align-items-start'>
                                                                <div className='d-flex align-items-center mb-1'>
                                                                    <div className='font-regular font-size2 color-subtext mb-1'>SL Limit</div>
                                                                </div>
                                                                <div className='input-group position-relative'>
                                                                    <div className='icon-12 icon-minus icon-grey input-number-left-wrap' name='intradayLimit' id='intradayLimitdecrease' onClick={() => handleOrderStepsOnChange('intradayLimit', 'decrease')}></div>
                                                                    <BzInputText size='sm' type='number' name='intradayLimit' value={orderInputs?.intradayLimit} className='p-0 font-regular text-center' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                                    <div className='icon-12 icon-add icon-grey input-number-right-wrap' name='intradayLimit' id='intradayLimitincrease' onClick={() => handleOrderStepsOnChange('intradayLimit', 'increase')}></div>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        {
                                                            toggleBracketOrder?.strProductType == ORDER_PRODUCT_TYPES.BRACKET &&
                                                            <Row className='mb-2'>
                                                                <Col md={6} className='flex-column align-items-start'>
                                                                    <div className='d-flex align-items-center mb-1'>
                                                                        <div className='font-regular font-size2 color-subtext mb-1'>Trailing SL</div>
                                                                    </div>
                                                                    <div className='input-group position-relative'>
                                                                        <div className='icon-12 icon-minus icon-grey input-number-left-wrap' name='intradayTrailing' id='intradayTrailingdecrease' onClick={() => handleOrderStepsOnChange('intradayTrailing', 'decrease')}></div>
                                                                        <BzInputText size='sm' type='text' name='intradayTrailing' value={orderInputs?.intradayTrailing} className='p-0 font-regular text-center' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                                        <div className='icon-12 icon-add icon-grey input-number-right-wrap' name='intradayTrailing' id='intradayTrailingincrease' onClick={() => handleOrderStepsOnChange('intradayTrailing', 'increase')}></div>
                                                                    </div>
                                                                </Col>
                                                                <Col md={6} className='flex-column align-items-start'>
                                                                    <div className='d-flex align-items-center mb-1'>
                                                                        <div className='font-regular font-size2 color-subtext mb-1'>Book Profit</div>
                                                                    </div>
                                                                    <div className='input-group position-relative'>
                                                                        <div className='icon-12 icon-minus icon-grey input-number-left-wrap' name='intradayProfit' id='intradayProfitdecrease' onClick={() => handleOrderStepsOnChange('intradayProfit', 'decrease')}></div>
                                                                        <BzInputText size='sm' type='text' name="intradayProfit" value={orderInputs.intradayProfit} className='p-0 font-regular text-center' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} onChange={handleOrderInputs} />
                                                                        <div className='icon-12 icon-add icon-grey input-number-right-wrap' name='intradayProfit' id='intradayProfitincrease' onClick={() => handleOrderStepsOnChange('intradayProfit', 'increase')}></div>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        }
                                                    </div>
                                                }
                                            </>
                                            //Azeem K :20-03-2025 : bracket and cover order hide as of now as per discussion with Poornima P will be taken in seprate user stoy --End
                                            //  Azeem K : 08-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End 
                                        }
                                        <Row className='g-0 my-4'>
                                            <Col>
                                                <div className='d-flex align-items-center'>
                                                    <div className='d-flex align-items-center cursor-pointer focus' id='amoValidityShowHide' onKeyPress={handleKeyDownOnDiv} tabIndex='0' onClick={() => setProfDesc(!profDesc)}>
                                                        {profDesc ? <div className='icon-14 icon-minus icon-dark me-2'></div> : <div className='icon-14 icon-add icon-dark me-2'></div>}
                                                        <div className='font-medium font-size1 color-text text-uppercase'>{profDesc ? <span>Hide</span> : <span>SHOW</span>} VALIDITY, AMO {(selectOrderOption?.validityTypes != ORDER_VALIDITY.IOC && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.NSE_DERIVATIVES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.BSE_DERIVATIVES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.MSX_DERIVATIVES) ? '& DISC.' + (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'QTY' : 'LOT') : null}</div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        {/* The below row should open when Clicked on 'SHOW PROT% & DISC. QTY' and the Text 'show' be replaced by 'Hide'*/}
                                        {profDesc &&
                                            <>
                                                <Row className='mb-3'>
                                                    <Col md={6} className='d-flex flex-column'>
                                                        <div className='d-flex align-item-start mb-1'>
                                                            <div className=' font-regular font-size2 color-subtext'>Validity</div>
                                                            <BzToolTip placement='right' TooltipMsg={strValidityMessage}>
                                                                <div className='icon-16 icon-info icon-dark flex-shrink-0 ms-1'></div>
                                                            </BzToolTip>
                                                        </div>
                                                        <div className='Bzmodalselect-dropdown'>
                                                            <BzDropdown>
                                                                <Dropdown.Toggle className='btn-default'>{selectOrderOption?.validityTypes}</Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    {validityTypes?.length > 0 && validityTypes?.map((eachOption, i) => (
                                                                        <Dropdown.Item key={i} onClick={(e) => { handleOnSelectOrderOptionChange({ target: { name: 'validityTypes', value: eachOption } }); }}>{eachOption}</Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            </BzDropdown>
                                                        </div>
                                                    </Col>
                                                    {
                                                        isGTDDropdown &&
                                                        <Col md={6} className='d-flex flex-column align-items-start'>
                                                            <div className='font-regular font-size2 color-subtext mb-1'>GTD Date</div>
                                                            <div className='datepicker-wrap p-0 mb-1 w-100'>
                                                                <BzDatePicker className='form-datepicker-secondary form-control form-control-sm font-medium py-1 px-2' defaultValue={orderInputs?.gtdDate} disabledDate={disabledDate} mode={'date'} dateFormat={"MMM DD, YYYY"} picker={"date"} onDateChange={onDateChange} />
                                                            </div>
                                                            <div className='font-medium font-size1 color-subtext'>GTD Days: <span className='color-text'>{nGTDNoOfDays}</span></div>
                                                        </Col>
                                                    }
                                                    {/* //BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start */}
                                                    {GTTValidDate && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT &&
                                                        <div className='d-flex align-items-start mt-2'>

                                                            <div className={`font-medium font-size1 color-subtext ms-1`}><span>Valid Till</span> <span className='color-text'>{GTTValidDate}</span></div>
                                                        </div>
                                                    }
                                                    {/* //BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End */}
                                                </Row>
                                                <Row className='mb-3'>
                                                    {
                                                        // selectOrderOption?.orderType?.includes('MKT') &&
                                                        // <Col className='me-3'>
                                                        //     <div className='font-regular font-size2 color-subtext mb-1'>Prot %</div>
                                                        //     <div className='input-group align-items-center form-control p-0 px-2'>
                                                        //         {/* Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start */}
                                                        //         <BzInputText size='sm' type='number' name='protPercent' value={orderInputs.protPercent} onChange={handleOrderInputs} className='text-left p-0 font-regular bdr-none' onBlur={onFocusOutInput} onKeyDown={onPriceInputsKeyDown} placeholder='0.00' />
                                                        //         {/* Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End */}
                                                        //         <div className='font-regular font-size2 color-subtext'>%</div>
                                                        //     </div>
                                                        // </Col>
                                                    }
                                                    {
                                                        (selectOrderOption?.validityTypes != ORDER_VALIDITY.IOC && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.NSE_DERIVATIVES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.BSE_DERIVATIVES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.MSX_DERIVATIVES) &&
                                                        <Col md={6} className='d-flex flex-column align-item-start'>
                                                            <div className='d-flex align-item-center mb-1'>
                                                                <div className='font-regular font-size2 color-subtext'>Disclosed {scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'Qty' : 'Lot'}</div>
                                                                <BzToolTip TooltipMsg='Disclosed quantity allows you to disclose only a part of the actual quantity you want to buy/sell.' placement='right'>
                                                                    <div className='icon-16 icon-info icon-dark flex-shrink-0 ms-1'></div>
                                                                </BzToolTip>
                                                            </div>
                                                            <BzInputText name='discQty' size='sm' type='number' value={orderInputs.discQty} onChange={handleOrderInputs} className='font-regular' onKeyDown={restrictInput} placeholder='0' />
                                                            <div className='d-flex justify-content-start align-items-center mt-1'>
                                                                <div className='font-medium font-size1 color-subtext'>Min Disc {scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'Qty: ' : 'Lot: '}
                                                                    <span className='color-text'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? + nMinDiscQty : + nMinDiscLot}</span>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    }
                                                    <Col md={6} className='d-flex align-items-start p-t-30'>
                                                        {/* // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start  */}
                                                        {bIsOCOAllowed && selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT ?
                                                            <>
                                                                <input type='checkbox' name='isOCOChecked' defaultChecked={selectOrderOption?.isOCOChecked} checked={selectOrderOption?.isOCOChecked} className='form-check-input me-2' value={selectOrderOption?.isOCOChecked} onChange={e => {
                                                                    handleOnSelectOrderOptionChange({ target: { name: e.target.name, value: !selectOrderOption?.isOCOChecked } });
                                                                }} />
                                                                <div className='font-medium font-size1 color-text text-uppercase me-1'>OCO</div>
                                                                <BzToolTip placement='top' TooltipMsg='The OCO (One Cancels Other) feature allows you to place two orders: Stop Loss (SL) and Profit booking. If either one is triggered, the system automatically cancels the other, ensuring profit protection and minimizing potential losses'>
                                                                    <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                                </BzToolTip>
                                                            </> :
                                                            selectOrderOption?.validityTypes !== ORDER_VALIDITY.GTT ?
                                                                <>  <input type='checkbox' name='isAmo' defaultChecked={selectOrderOption?.isAmo} checked={selectOrderOption?.isAmo} className='form-check-input me-2' value={selectOrderOption?.isAmo} onChange={e => {
                                                                    handleOnSelectOrderOptionChange({ target: { name: e.target.name, value: !selectOrderOption?.isAmo } });
                                                                }} />
                                                                    <div className='font-medium font-size1 color-text text-uppercase me-1'>AMO</div>
                                                                    <BzToolTip placement='top' TooltipMsg='After Market Order(AMO) is a trade that allows you to buy/sell outside of regular trading hours'>
                                                                        <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                                    </BzToolTip>
                                                                </> : null}
                                                        {/* // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End */}
                                                    </Col>
                                                    {/* Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Stat
                                                                      BREEZE-4394 LLD Creation :OCO checkbox will add here for side tray order entry
                                                        Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End*/}
                                                </Row>
                                            </>
                                        }

                                        {/* market depth and support resistance button - start */}
                                        {
                                            isShowMarketDepth && (
                                                <>
                                                    <div className='bdr-top py-3' ref={marketDepthRef}>
                                                        <div className='submenu-wrapper d-flex align-items-center'>
                                                            <div onClick={() => setMarketDepthActiveTab('market_depth')} className={`submenuItem ${marketDepthActiveTab == 'market_depth' ? 'active' : ''}`}>Market Depth</div>
                                                            <div onClick={() => setMarketDepthActiveTab('support_resistance')} className={`submenuItem ${marketDepthActiveTab == 'support_resistance' ? 'active' : ''}`}>Support/Resistance</div>
                                                        </div>
                                                        {
                                                            marketDepthActiveTab === 'market_depth' ?
                                                                <>
                                                                    <BzTabs className='nav nav-tabs horizontal-scroll-wrap my-2 d-flex flex-row'>
                                                                        {
                                                                            arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((each, i) =>
                                                                                <BzTab key={i} className={`nav-link text-capitalize ${each[WATCHLIST_GRID_INDEX.SEGMENT_ID] == marketDepthTab ? 'active' : ''}`} tabKey={each[WATCHLIST_GRID_INDEX.SEGMENT_ID]} onClick={() => setMarketDepthTab(each[WATCHLIST_GRID_INDEX.SEGMENT_ID])}>
                                                                                    {each[WATCHLIST_GRID_INDEX.EXCHANGE]}
                                                                                </BzTab>
                                                                            )
                                                                        }
                                                                    </BzTabs>
                                                                    {
                                                                        arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((each, i) =>
                                                                            each[WATCHLIST_GRID_INDEX.SEGMENT_ID] == marketDepthTab && <MarketDepthGrid onValueClick={onValueClick} layoutType={LAYOUT_TYPE.VERTICAL} ref={[createRef(), createRef()]} key={i} scripData={each} />
                                                                        )
                                                                    }
                                                                </>
                                                                : marketDepthActiveTab === 'support_resistance' ? <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} layoutType={LAYOUT_TYPE.VERTICAL} /> : null
                                                        }
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>
                                </>}
                            {/* market depth and support resistance button - end */}
                        </Container>
                    </div>
                    : null
            }

        </>
    );
});

export default memo(OrderSingleScrip);
